<template>
  <!--说明书-->
  <div id="myInstructionBook" v-show="showPage">
    <div class="prodDiv">
      <div @click="clickProd(1)" :class="selProd === 1 ? 'onProdDiv' : ''">
        <p>myPKFit</p>
        <p>产品说明书</p>
      </div>
      <div @click="clickProd(2)" :class="selProd === 2 ? 'onProdDiv' : ''">
        <p>百因止</p>
        <p>产品说明书</p>
      </div>
    </div>
    <div>
      <img src="../../assets/pkbockbg.png" width="100%" class="p_r" style="z-index: 5"/>
      <!--myPKFit-->
      <div v-if="selProd === 1">
        <div class="navigateDiv p_r" style="z-index: 10">
          <div v-if="showMenu" class="navigateDivMenu">
            <nav>
              <span class="font16 m_r_10 color_793286 f_w">导航</span><img src="../../assets/gps.png" height="16" width="16"/>
            </nav>
            <div>
              <ul>
                <li :key="index" v-for="(item, index) in bookMenu">
                  <a :href="'#' + item.divID" :class="seltMenuID === item.divID ? 'f_w' : ''"  @click="seltNavigate($event,item)">{{ item.name }}</a>
                </li>
              </ul>
              <div class="allTriangle d_i" style="transform: rotate(-90deg)" @click="showMenu = false"></div>
            </div>
          </div>
          <div v-else class="navigateDivOp" @click="showMenu = true">
            <span>说明书导航</span>
            <div class="allTriangle d_i v_m m_t_10" style="transform: rotate(90deg)"></div>
          </div>
        </div>
        <div class="allProBody p_r">
          <img src="../../assets/book.png" height="12" width="12" class="p_a" style="top: -6px;left: -6px"/>
          <div>
            <div class="t_c"><img src="../../assets/til01.png" width="50%"/></div>
            <h1 class="color_793286 f_w t_c" style="margin-bottom: 40px">
              注射用重组人凝血因子VIII剂量<br>
              计算软件<br>
              使用说明
            </h1>
            <p class="t_c m_b_10">
              <span>本使用说明适用于</span><span class="f_w color_793286">myPKFiT</span><span>软件2.0.11版本</span>
            </p>
            <p class="t_r m_b_20">注射用重组人凝血因子VIII剂量计算软件</p>
            <div class="t_r d_flex m_b_20" style="justify-content: flex-end">
              <img src="../../assets/til02.png" height="48" width="48"/>
              <span class="t_l">
                百深美国<br>
                1200 Lakeside Drive<br>
                Bannockburn, IL USA 60015
              </span>
            </div>
            <div class="t_r d_flex m_b_20" style="justify-content: flex-end">
              <div>
                <img src="../../assets/til03.png" width="60" class="m_b_5"/><br>
                <img src="../../assets/til04.png" width="40"/>
              </div>
              <span>
                Promedt<br>
                Altenhofstr. 80<br>
                66386 St. Ingbert | Germany
              </span>
            </div>
            <p class="m_b_20">
              <span class="f_w">百深、百因止</span><span>和</span><span class="f_w color_793286">myPKFiT</span><span>为百深股份有限公司（ Baxalta Incorporated）的注册商标。本说明书中出现的其他商标、产品品牌或图像都归属其各自的持有者。</span>
            </p>
            <p class="t_r m_b_40">仅限处方药。</p>
          </div>
          <div id="fit01">
            <p class="f_w color_blue00458d m_b_20 font16">1. 简介</p>
            <p class="f_w color_blue00458d m_b_10 font16">1.1 概要</p>
            <p class="m_b_20">
              <span>
                [名称]：注射用重组人凝血因子VIII剂量计算软件<br>
                [型号规格]：myPKFiT for ADVATE, 发布版本2.0.11<br>
                [结构组成]：本产品为基于网络的应用软件，临床功能模块包括：患者管理、医院用户管理、PK评估、添加样本、PK特征曲线、剂量计算和创建/查看报告。<br>
                [注册人名称、住所]： Baxalta US Inc.，1200 Lakeside Drive Bannockburn, IL USA 60015<br>
                [代理人的名称、住所]： 百深生物科技（上海）有限公司，中国（上海）自由贸易试验区泰谷路18号1幢楼17层1706室<br>
                [生产企业的名称、住所、生产地址]：Baxalta US Inc.，1200 Lakeside Drive Bannockburn, IL USA 60015<br>
                [联系方式及售后服务单位]：请参见www.mypkfit.cn的“联系我们”页面<br>
                [医疗器械注册证编号]：国械注进20203210480<br>
                [使用期限]：10年<br>
                [说明书的编制日期]：2020年11月<br>
                注射用重组人凝血因子VIII剂量计算软件在</span><span class="f_w color_793286">本说明书中以myPKFiT简称。</span>
            </p>
            <p class="f_w color_blue00458d m_b_20 font16">1.2 可靠性陈述</p>
            <p class="f_w color_blue00458d m_b_10 font16">1.2.1 成熟性</p>
            <p class="m_b_20">在最低运行环境下，20条患者数据，最大并发用户数3条件下，使用说明中的所有功能均可正常运行。</p>
            <p class="f_w color_blue00458d m_b_10 font16">1.2.2 可用性</p>
            <p class="m_b_20">一周7天每天24小时无宕机。</p>
            <p class="f_w color_blue00458d m_b_10 font16">1.2.3 容错性</p>
            <p class="m_b_20">使用无效数据时，会产生预期的错误或警告，警告数据不影响软件的正常运行，错误数据软件不响应，使用说明书提供了具体的错误或警告提示。</p>
            <p class="f_w color_blue00458d m_b_10 font16">1.2.4 易恢复性</p>
            <p class="m_b_20">网站出于安全起见设置了自动退出属性。如果30分钟网站不活动则会自动中断，用户会被转到登陆页面，重新登陆后用户之前保存的数据不会丢失。如遇网络中断等情况，网络恢复后用户已保存的数据不会丢失。如遇浏览器程序错误等故障，可重启或重装浏览器，用户已保存的数据不会丢失。</p>
            <p class="f_w color_blue00458d m_b_20 font16">1.2.5 使用过程中如遇不可预知的应用程序错误，可重新登陆软件，已保存的数据不会丢失，用户可继续进行操作。</p>
            <p class="f_w color_blue00458d m_b_10 font16">1.2.6 数据库的更新信息实时从主服务器复制到辅助服务器。每天（周一至周六）进行增量备份，并在周日进行每周完整备份，我公司保留最近的15个增量备份和最近的6个完整备份。</p>
            <p class="m_b_10">
              <span class="f_w color_793286">myPKFiT</span><span>为一款基于网络的应用程序。借助于此，获验证用户可以通过个体患者的药代动力学（PK）特征曲线来模拟其剂量方案。本使用手册向用户提供该软件全部功能的概述。如欲需求额外帮助或了解更多，请参见本手册第1.5章节的支持内容。</span>
            </p>
            <p class="m_b_20">
              <span class="f_w color_793286">myPKFiT</span><span>使用大于用户指定阈值的注射用重组人凝血因子VIII活性数值来指导医生确定合适的药物剂量和输注给药频率。这对于因子VIII半衰期短的患者尤为重要。</span>
            </p>
            <p class="f_w color_blue00458d m_b_20 font16">1.3 使用指导</p>
            <p class="f_w color_blue00458d m_b_10 font16">1.3.1 使用环境</p>
            <p class="m_b_20">
              <span class="f_w color_793286">myPKFiT</span><span>软件将供医疗机构使用。</span>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">1.3.2 预期用途</p>
            <p class="m_b_10">
              <span class="f_w color_793286">myPKFiT</span><span>软件适用于16岁及以上和体重45 kg及以上的血友病A患者，根据其凝血因子VIII实验室数据和个人信息估算个体凝血因子FVIII PK参数，并以此参数计算预防治疗剂量（即规律性替代治疗剂量），供熟悉血友病A治疗的执业医疗专业人士（HCP）使用。HCP还可以根据患者的个人需要和治疗计划生成不同的输注模型。该医疗软件的输出数据将用来指导制定相关的FVIII剂量以及给药间隔，目的是根据百因止（注射用重组人凝血因子VIII）说明书中提供的建议剂量使患者个人的FVIII水平等于或高于特定阈值。</span>
            </p>
            <p class="m_b_10">
              <span class="f_w color_793286">myPKFiT</span><span>软件与患者数据间无直接界面。患者的个体数据将被加密保存在第三方中央数据存储服务器中。</span>
            </p>
            <p class="m_b_10">
              <span class="f_w color_793286">myPKFiT</span><span>只能接受注射用重组人凝血因子VIII治疗患者的给药方案，不适用于其他注射用重组人凝血因子VIII产品。</span>
            </p>
            <p class="m_b_20">
              <span>根据批准的百因止处方信息，</span><span class="f_w color_793286">myPKFiT</span><span>仅用于指导计算血友病A患者规律性替代治疗的FVIII剂量以防止出血，不适用于血管性血友病，也不适用于已产生FVIII中和抗体（抑制物）的患者。医疗专业人士拥有根据患者病情和个人需要来决定FVIII输注剂量。</span>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">1.4 描述和功能</p>
            <p class="m_b_10">
              <span class="f_w color_793286">myPKFiT</span><span>有以下几种功能：</span>
            </p>
            <ul class="m_b_20">
              <li>
                <i class="allDots back_colorPurple642483"></i>
                <span>用户管理——使授权用户得以创建和管理其所在医院/治疗中心HCP的用户账号。</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483"></i>
                <span>患者管理——HCP可创建及保有患者记录。</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483"></i>
                <span>评估——根据实验室的FVIII数据，HCP可以创建个体化的患者PK特征曲线。</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483"></i>
                <span>剂量计算——HCP可以计算FVIII剂量和输注计划。</span>
              </li>
            </ul>
            <p class="f_w color_blue00458d m_b_10 font16">1.5 导航</p>
            <p class="m_b_10">
              <span class="f_w color_793286">myPKFiT</span><span>使用标准导航功能和其他在一般网站常见的控制功能（选项框、音频按钮等）。这些控制功能包括：</span>
            </p>
            <table class="proTable m_b_20">
              <tbody>
              <tr>
                <td class="f_w color_793286">日历</td>
                <td class="t_c"><img src="../../assets/til05.png" width="80%"/></td>
                <td>日历功能用来显示每月日历，用户可以借此选择日期、移动至之后和之前的月份。</td>
              </tr>
              <tr>
                <td class="f_w color_793286">时间选择</td>
                <td class="t_c"><img src="../../assets/til06.jpg" width="80%"/></td>
                <td>时间功能显示24小时时钟，用户可以选择特定时间（小时及分钟）。</td>
              </tr>
              <tr>
                <td class="f_w color_793286">选项框</td>
                <td class="t_c"><img src="../../assets/til07.png" width="80%"/></td>
                <td>
                  用户可以通过在选项框上点击鼠标来选择或者取消选择。<br>
                  选择时，该选项框被填满。未选择时，该选项框为空。
                </td>
              </tr>
              <tr>
                <td class="f_w color_793286">下拉菜单</td>
                <td class="t_c"><img src="../../assets/til08.png" width="80%"/></td>
                <td>
                  这一功能有时是指下拉菜单、下拉选框或下推菜单。下拉菜单显示为向下指的箭头。点击箭头时会出现菜单或列表。您可以在此列表中选择一个选项。
                </td>
              </tr>
              <tr>
                <td class="f_w color_793286">区域</td>
                <td class="t_c">
                  <img src="../../assets/til09.png" width="100%" class="m_b_10"/>
                  <img src="../../assets/til10.png" width="90%" class="m_b_10"/>
                  <img src="../../assets/til11.png" width="80%"/>
                </td>
                <td>
                  区域（有时指文本框）是可输入信息/数值的位置。<br>
                  <span class="f_w color_793286">允许使用小数点的区域：</span><span>在填写体重、输注前FVIII水平以及样本FVIII水平区域时，此工具仅允许使用小数点后一位。如果您试图在这些区域输入小数点后一位以上的数值，会显示错误消息，您将无法继续操作。</span><br>
                  此工具允许在输入低于定量限制（BLQ）区域的FVIII水平时使用小数点后三位的数值。如果您试图在这些区域输入小数点后三位以上的数值，会显示错误消息，您将无法继续操作。<br>
                  如果您试图在任何其他区域（包括FVIII PK总剂量、之前输注的FVIII总剂量以及基线以上目标值）输入带有小数点的数值，该数值会变成红色并出现错误消息。您无法继续操作。
                </td>
              </tr>
              <tr>
                <td class="f_w color_793286">悬停</td>
                <td class="t_c"><img src="../../assets/til12.png" width="80%"/></td>
                <td>
                  当悬停时，将鼠标箭头停留在某特定位置但不要选择或者点击。这样就会出现一个气球，显示更多信息。
                </td>
              </tr>
              <tr>
                <td class="f_w color_793286">图标</td>
                <td class="t_c"><img src="../../assets/til13.png" width="80%"/></td>
                <td>
                  图标为可代表某一文件或某一功能的小型图像或标识。
                </td>
              </tr>
              <tr>
                <td class="f_w color_793286">链接</td>
                <td class="t_c"><img src="../../assets/til14.png" width="80%"/></td>
                <td>
                  链接（有时指超级链接）是电脑屏幕上带高亮下划线的单词、短句或图形。用鼠标箭头点击时，用户会被带入工具中的另一位置，或者不同的网站。
                </td>
              </tr>
              <tr>
                <td class="f_w color_793286">弹出窗口</td>
                <td class="t_c"><img src="../../assets/til15.png" width="80%"/></td>
                <td>
                  当您用鼠标点击链接时，弹出窗口会出现在已有屏幕或窗口的顶部。弹出窗口用来显示信息和链接。如欲关闭此弹出窗口，请点击取消弹出窗口。
                </td>
              </tr>
              <tr>
                <td class="f_w color_793286">滑块</td>
                <td class="t_c"><img src="../../assets/til16.png" width="80%"/></td>
                <td>
                  点击滑块按钮并将它上下滑动就可以增加或减少某个数值。
                </td>
              </tr>
              <tr>
                <td class="f_w color_793286">叠放</td>
                <td class="t_c"><img src="../../assets/til17.png" width="80%"/></td>
                <td>
                  项目被垂直叠放列出。每一项都可以“扩展”或“收缩”以显示/隐藏内容。点击某叠放菜单可扩展关闭的菜单，或者将已打开的菜单折叠。
                </td>
              </tr>
              <tr>
                <td class="f_w color_793286">错误</td>
                <td class="t_c">
                  <img src="../../assets/til18.png" width="60%" class="m_b_10"/>
                  <img src="../../assets/til19.png" width="100%"/>
                </td>
                <td>
                  当输入数值不正确时，系统将会显示错误消息。根据不同情况，会出现浅红色消息或者弹出窗口。在进行下一步操作之前，您必须先修正这些信息。
                </td>
              </tr>
              <tr>
                <td class="f_w color_793286">警告</td>
                <td class="t_c">
                  <img src="../../assets/til20.png" width="80%"/>
                </td>
                <td>
                  当输入的数值超出范围时，您会收到警告。这仅为提醒，不会阻止您在此区域输入该数值。
                </td>
              </tr>
              </tbody>
            </table>
            <p class="f_w color_blue00458d m_b_20 font16">1.6 用户帮助信息</p>
            <p class="f_w color_blue00458d m_b_10 font16">1.6.1 百深支持</p>
            <p class="m_b_20">
              请参见www.mypkfit.cn的“联系我们”页面。<br>
              本软件由本公司负责维护和升级，用户不需要进行维护操作。本公司会根据实际运营情况不定时升级，升级操作不会影响用户使用。
            </p>
          </div>
          <div id="fit02">
            <p class="f_w color_blue00458d m_b_20 font16">2 登入/登出</p>
            <p class="f_w color_blue00458d m_b_10 font16">2.1 概要</p>
            <p class="m_b_20">
              此章节将说明如何登入/出本应用程序、重置密码以及更新账户设置。
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">2.2 登入</p>
            <p>
              <span>如欲使用</span><span class="f_w color_793286">myPKFiT</span><span>，在您的网站浏览器地址栏中输入如下URL：</span><br>
              www.mypkfit.cn<br>
              <span class="f_w color_793286">myPKFiT</span><span>支持以下网络浏览器：</span>
            </p>
            <ul class="m_l_20">
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>Internet Explorer 11</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>Firefox 38.0.1</span>
              </li>
            </ul>
            <p class="m_b_10">
              <span>为了安装以上浏览器，需确保电脑磁盘空间不少于</span>
              <span class="f_w">100MB</span>
              <span>。不建议使用旧版网络浏览器，因其可能导致无法提供丰富的用户友好体验。如果未使用Internet Explorer 11或Firefox 38.0.1进行浏览，</span>
              <span class="f_w color_793286">myPKFiT</span>
              <span class="f_w">会提示警告信息。如果试图使用</span>
              <span>Internet Explorer 9或更低版本进行用户登陆，</span>
              <span class="f_w color_793286">myPKFiT</span>
              <span class="f_w">会提示错误信息并阻止用户登陆。</span>
            </p>
            <p class="m_b_10"><img src="../../assets/til21.png" width="100%"/></p>
            <p>
              登入页面将显示和包括如下内容：
            </p>
            <ul class="m_l_20 m_b_20">
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>登入窗口</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>详细风险信息窗口：</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10" style="visibility: hidden"></i>
                <div class="d_i v_m" style="width: calc(100% - 30px)">
                  <img src="../../assets/til22.png" width="105"/>
                  <span>点击</span><span class="color_793286">‘展开’</span><span>按钮以查看更多内容。</span>
                </div>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10" style="visibility: hidden"></i>
                <div class="d_i v_m" style="width: calc(100% - 30px)">
                  <img src="../../assets/til23.png" width="123"/>
                  <span>点击</span><span class="color_793286">‘百因止处方信息’</span><span>按钮，您将被带入可以查看百因止产品特征概要（SPC）信息的网页。</span>
                </div>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>免责声明（在窗口底部）</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>下拉菜单（窗口右上角）</span>
              </li>
            </ul>
            <p class="f_w color_blue00458d m_b_10 font16">2.2.1 申请用户账号</p>
            <p class="m_b_20">
              您需要联系您当地的管理员以申请用户账号。一旦创建好账户，您就会收到一封用于激活账号的电子邮件。激活链接将在10天后过期。如果链接过期，请联系您当地的管理员。<br>
              <span>一旦点击电子邮件里的链接，您将会进入</span><span class="f_w color_793286">myPKFiT</span><span>的初始登入窗口并被要求创建密码。</span>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">2.2.2 首次登入</p>
            <p class="m_b_10"><img src="../../assets/til24.png" width="100%"/></p>
            <p style="font-style:oblique" class="color_793286">密码设定要求：</p>
            <ul style="font-style:oblique" class="color_793286 m_b_10 m_l_20">
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>密码的长度至少要包含8个字母和数字字符。</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>密码至少要包含1个数字和1个字母。</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>新建密码不可与之前的4个密码重复。 </span>
              </li>
            </ul>
            <p style="font-style:oblique" class="color_793286">首次登入后您需要阅读并接受条款和条件以及隐私政策，方可开始使用本应用程序。</p>
            <p><img src="../../assets/til25.png" width="100%"/></p>
            <p style="font-style:oblique" class="color_793286 m_b_10">
              <span>阅读后在选框内打勾表示同意，并点击‘确定’按钮。</span><img src="../../assets/til26.jpg" width="35"/>
            </p>
            <p style="font-style:oblique" class="color_793286 m_b_10">注：如果将来条款和条件或隐私政策随时有所更新，您需要及时重新接受。</p>
            <p class="m_b_10">一旦接受条款和条件及隐私政策，您将需要选择两个安全问题。这些问题会在您希望找回忘记的密码时向您提出。</p>
            <p class="m_b_10"><img src="../../assets/til27.png" width="100%"/></p>
            <p class="m_b_20">
              从下拉菜单中选择安全问题1。<br>
              在回答安全问题区域填入答案。<br>
              在安全问题2重复这些步骤。<br>
              <span>点击</span><span class="color_793286">‘确认’</span><span>按钮</span><img src="../../assets/til26.jpg" width="35"/>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">2.2.3 找回忘记的密码</p>
            <p>
              <span>您忘记密码时，可以通过点击登入页面上的</span><span class="color_793286">‘忘记密码’</span><span>链接来设置新的密码。</span><br>
              您将被要求填入您的电子邮件地址并回答链接到电子邮件地址的安全问题。一旦成功输入有效电子邮件和安全答案，您将收到带有更改密码链接的电子邮件邮件。
            </p>
            <p class="m_b_20"><img src="../../assets/til28.png" width="100%"/></p>
            <p class="f_w color_blue00458d m_b_10 font16">2.3 登出</p>
            <p>
              <span>为避免潜在技术问题，在您每次关闭视窗或视窗标签前请使用登出选项退出</span><span class="f_w color_793286">myPKFiT</span><span>应用程序。</span><br>
              <span>在右上角点击下拉菜单。点击</span><span class="color_793286">‘登出’</span><span>。</span>
            </p>
            <p class="m_b_10"><img src="../../assets/til29.png" height="188" width="183"/></p>
            <p class="m_b_20">注：网站出于安全起见设置了自动退出属性。如果30分钟网站不活动则会自动中断，用户会被转到登陆页面。</p>
            <p class="f_w color_blue00458d m_b_10 font16">2.4 账户设置</p>
            <p class="m_b_10">
              <span>通过点击</span><span class="color_793286">‘账户设置’</span><span>，您将会进入账户设置窗口。</span>
            </p>
            <p>在账户设置窗口，您可以修改如下设置：</p>
            <ul class="m_b_10 m_l_20">
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>更改密码</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>更改电子邮件地址</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>更改安全问题</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>编辑首选项</span>
              </li>
            </ul>
            <p class="m_b_20"><img src="../../assets/til30.png" width="100%"/></p>
            <p class="f_w color_blue00458d m_b_10 font16">2.4.1 更改密码</p>
            <p class="m_b_10">点击链接以更改密码。</p>
            <p class="m_b_10"><img src="../../assets/til31.png" width="100%"/></p>
            <p><span>您需要填写您之前的密码，然后是您的新密码，最后点击</span><span class="color_793286">‘保存’</span><span>按钮。您就可以收到确认消息。</span></p>
            <p><img src="../../assets/til32.png" width="100%"/></p>
            <p class="m_b_20">注：点击‘密码设置要求’ 超级链接可以查看密码设置要求。</p>
            <p class="f_w color_blue00458d m_b_10 font16">2.4.2 变更邮件地址</p>
            <p class="m_b_10">点击链接更改您的电子邮件地址。</p>
            <p><img src="../../assets/til33.png" width="100%"/></p>
            <p>
              <span>输入您的新电子邮件地址以及密码，然后点击</span><span class="color_793286">‘保存’</span><span>按钮。</span><br>
              您将看到电子邮件地址已更改的确认消息。
            </p>
            <p class="m_b_20"><img src="../../assets/til34.png" width="100%"/></p>
            <p class="f_w color_blue00458d m_b_10 font16">2.4.3 更改安全问题</p>
            <p class="m_b_10">点击超级链接以更改您的安全问题。</p>
            <p><img src="../../assets/til35.png" width="100%"/></p>
            <p class="m_b_20">
              选择其他安全问题和/或更改答案。<br>
              <span>输入您的密码以确认更改，然后点击</span><span class="color_793286">‘保存’</span><span>。</span><br>
              <img src="../../assets/til36.png" width="80%"/>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">2.4.4 编辑首选项</p>
            <p class="m_b_10">点击超级链接以进入您的账户首选项页面。</p>
            <p><img src="../../assets/til37.png" width="100%"/></p>
            <p class="m_b_20">
              在此窗口您可以选择其他的语言或首选医院（如果您为一个以上医院工作）。<br>
              您将会收到您的首选项已完成更改的确认消息。<br>
              <img src="../../assets/til38.png" width="100%"/>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16"><span>2.4.5 回到</span><span class="color_793286">myPKFiT</span><span>控制面板</span></p>
            <p class="m_b_10"><span>点击</span><span class="f_w color_793286">myPKFiT</span><span>图标回到</span><span class="f_w color_793286">myPKFiT</span><span>控制面板</span></p>
            <p class="m_b_20"><img src="../../assets/til39.png" width="100%"/></p>
          </div>
          <div id="fit03">
            <p class="f_w color_blue00458d m_b_20 font16">3 myPKFiT控制面板</p>
            <p class="f_w color_blue00458d m_b_10 font16">3.1 概要</p>
            <p class="m_b_20">
              <span>这部分介绍了</span><span class="f_w color_793286">myPKFiT</span><span>面板的内容。</span><br>
              一旦成功登陆，就会出现包含有患者选项的面板。<br>
              <img src="../../assets/til40.png" width="100%"/><br>
              注：如果您有用户管理员权限，您还会在此页面上看到管理选项。参见本说明书用户管理章节。
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">3.2 患者面板</p>
            <p class="m_b_20">
              <span>在患者面板，您可以使用</span><span class="color_793286">‘我的患者’</span><span>选项管理您目前的患者，使用</span><span class="color_793286">‘添加患者’</span><span>选项添加新患者。</span><br>
              <span>在帮助及常见问题解答面板，您可以通过点击</span><span class="color_793286">‘帮助及常见问题解答’</span><span>图标以查看与使用本应用程序有关的一般性问题。</span>
            </p>
          </div>
          <div id="fit04">
            <p class="f_w color_blue00458d m_b_20 font16">4 患者管理</p>
            <p class="f_w color_blue00458d m_b_10 font16">4.1 概要</p>
            <p class="m_b_20">作为医院用户，您有权限创建、激活或停用患者，以及为您的患者创建评估。</p>
            <p class="f_w color_blue00458d m_b_10 font16">4.2 创建新患者</p>
            <p>
              <span>在患者面板，点击图标</span><span class="color_793286">‘添加患者’</span><span>。</span><br>
              在新窗口会出现信息区域，如：
            </p>
            <ul class="m_l_20 m_b_10">
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>
                  <span class="f_w color_793286">临床患者ID*：</span><span>在创建新患者时必需填写这一区域，可以包含长度至多为20个字符的字母和数字。</span>
                </span>
              </li>
            </ul>
            <p style="font-style:oblique" class="color_793286 m_b_10">
              <span>注：患者ID区域的唯一目的是为找到医院患者的资料。这一区域</span><span class="f_w" style="text-decoration: underline">不应用于保存患者的个人信息</span><span>如姓名、姓名缩写或出生日期。</span>
            </p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="font16 f_w color_793286">错误</span><br>
                每个患者都有单一的识别号。如果您用已有ID来创建新患者，就会在一般患者信息窗口弹出信息。
                <img src="../../assets/til41.png" width="100%"/>
              </p>
            </div>
            <p><img src="../../assets/til42.png" width="100%"/></p>
            <p class="m_l_20">
              <i class="allDots back_colorPurple642483 m_r_10"></i>
              <span>
                  <span class="f_w color_793286">出生年份*：</span><span>需在此输入出生年份。此区域也属于必填项。</span>
                </span>
            </p>
            <p style="font-style: oblique" class="color_793286">
              <span>注：</span><span class="f_w">myPKFiT</span><span>预期患者的年龄为16岁或以上。用户不可为16岁以下的患者创建患者特征曲线（标准基于创建时的年份和季度）。所选的出生年度和季度将受系统限定。</span>
            </p>
            <p class="m_l_20">
              <i class="allDots back_colorPurple642483 m_r_10"></i>
              <span>
                  <span class="f_w color_793286">出生季度*：</span><span>应在此处输入患者出生日期所属的季度。仅年满16岁的ADVATE患者必须填写此字段。</span>
                </span>
            </p>
            <p style="font-style: oblique" class="color_793286">注： 如果用户所创建ADVATE 评估的FVIII PK 输注日期在患者年满17岁之前，那么也必须填写出生季度字段。</p>
            <p class="m_l_20">
              <i class="allDots back_colorPurple642483 m_r_10"></i>
              <span>
                  <span class="f_w color_793286">FVIII基线*：</span><span>FVIII基线为内源性FVIII水平，不包括之前通过输注的外源性残余FVIII存量。从＜1%至5%中选择一个建议值。</span>
                </span>
            </p>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：必填项目标示有星号（＊）。</p>
            <p>
              <span>点击确认按钮</span><img src="../../assets/til26.jpg" width="20"/><span>将确定您输入的日期并生成新患者。</span><br>
              本应用程序将建议于此开始为该患者创建新评估。
            </p>
            <p><img src="../../assets/til43.png" width="100%"/></p>
            <p style="font-style: oblique" class="color_793286">
              <span>注：如果点击按钮</span><img src="../../assets/til44.png" width="20"/><span>就会保存您的患者，您会被带入‘我的患者’窗口。</span>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">4.3 管理已有患者（我的患者）</p>
            <p class="m_b_20">
              <img src="../../assets/til45.png" width="40" style="vertical-align: bottom"/>
              <span>从主控制面板的患者面板，您可以通过点击此图标来查看</span><span class="color_793286">‘我的患者’</span><span>菜单。</span><br>
              <img src="../../assets/til46.png" width="100%"/>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">4.3.1 过滤查看</p>
            <p>
              <img src="../../assets/til47.png" width="100" style="vertical-align: bottom"/>
              点击箭头打开过滤选项后就可以过滤查看。<br>
              <span>选择</span><span class="color_793286">‘已激活’</span><span>可以仅查看目前在您的治疗中心接受治疗的患者，或点击</span><span class="color_793286">‘未激活’</span><span>查看不再接受治疗的患者。</span><br>
            </p>
            <p style="font-style: oblique" class="color_793286 m_b_20">
              注：当您首次登入本应用程序时，所有已激活和未激活的患者都会默认显示。
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">4.3.2 搜索功能</p>
            <p class="m_b_20">
              在患者列表顶部有搜索选项。<br>
              <span>在</span><span class="color_793286">‘搜索’</span><span>区域填写</span><span class="color_793286">患者ID</span><span>或</span><span class="color_793286">患者出生年度</span><span>的部分关键词，随着您的输入，就会得到相应的检索结果。</span><br>
              <img src="../../assets/til48.png" width="100%"/>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">4.3.3 PK评估</p>
            <p class="m_b_20">
              <img src="../../assets/til49.png" width="50" style="vertical-align: bottom"/>
              <span>点击</span><span class="color_793286">‘听诊器’</span><span>图标，您就可以查看患者的PK评估内容。</span>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">4.3.4 激活/停用患者</p>
            <p>
              您可以通过在患者列表右侧的选框中打勾/去掉打勾来激活/停用患者。<br>
              未激活的患者栏将变为灰色阴影。选框里没有打勾。<br>
              <img src="../../assets/til50.png" width="100%"/><br>
            </p>
            <p style="font-style: oblique" class="color_793286 m_b_20">注：停用患者并不会删除该患者的记录。您可以随时再激活之前曾停用的患者。</p>
            <p class="f_w color_blue00458d m_b_10 font16">4.3.5 创建新患者</p>
            <p class="m_b_20">
              <img src="../../assets/til51.png" width="50" style="vertical-align: bottom"/>
              您还可以通过点击页面右上角的图标，在“我的患者”页面创建新患者。<br>
            </p>
          </div>
          <div id="fit05">
            <p class="f_w color_blue00458d m_b_20 font16">5 患者评估</p>
            <p class="f_w color_blue00458d m_b_10 font16">5.1 概要</p>
            <p class="m_b_10">
              此章节将说明如何在工具中创建新的患者评估。<br>
              您可以在创建新患者后立即对其进行评估（如之前4.2节所述）。<br>
              <img src="../../assets/til52.png" width="100%" class="m_b_10"/><br>
              或者，您也可以为已有患者创建新评估。<br>
              <img src="../../assets/til45.png" width="50" style="vertical-align: bottom"/>
              <span>点击</span><span class="color_793286">‘我的患者’</span><span>图标以查看已有患者列表。</span><br>
              <img src="../../assets/til53.png" width="100%" class="m_b_10"/><br>
              <img src="../../assets/til49.png" width="50" style="vertical-align: bottom"/>
              <span>点击</span><span class="color_793286">‘听诊器’</span><span>图标以访问患者的PK评估页面。</span><br>
              <img src="../../assets/til54.png" width="100%" class="m_b_10"/><br>
              <img src="../../assets/til55.jpg" width="50" style="vertical-align: bottom"/>
              <span>在‘PK评估’面板，点击</span><span class="color_793286">‘添加PK评估’</span><span>图标以为该患者添加新的评估。</span><br>
              <img src="../../assets/til56.png" width="100%"/><br>
            </p>
            <p>屏幕上将显示如下内容的叠放菜单：</p>
            <ul class="m_b_20 m_l_20 color_793286 f_w">
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>患者信息</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>一般性PK评估信息</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>之前的PK评估 </span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>样本</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>PK档案</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>剂量计算</span>
              </li>
              <li>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>已保存的PDF</span>
              </li>
            </ul>
            <p class="f_w color_blue00458d m_b_10 font16">5.2 患者信息</p>
            <p>
              患者信息将显示您之前创建患者时输入的相关信息。<br>
              <img src="../../assets/til57.png" width="100%"/><br>
              <span>如果您需要查看或编辑这些信息，请点击</span><span class="color_793286">‘铅笔’</span><span>图标</span><img src="../../assets/til58.png" width="20"/>
            </p>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：创建完成后，您将被要求确认对患者信息做出的更改。</p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_20">
              <p>
                <span class="f_w font16 color_793286">警告</span><br>
                如果更改患者的出生年度／季度或FVIII基线，您需要知道任何以前的评估将无法根据新信息进行自动更新，该患者之前的PK特征曲线和剂量计算将不再准确。
              </p>
            </div>
            <p class="f_w color_blue00458d m_b_10 font16">5.3 一般性PK评估信息</p>
            <p>
              <img src="../../assets/til59.png" width="100%" class="m_b_10"/><br>
              在此部分，您需要填写剂量、输注日期时间以及患者目前的体重等输注信息。
            </p>
            <p class="m_l_20">
              <i class="allDots back_colorPurple642483 m_r_10"></i>
              <span>
                  <span class="f_w color_793286">体重：</span><span>输入患者体重（kg）。您可以输入小数点后一位的数字。</span>
                </span>
            </p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                无法输入低于45 kg或高于120 kg的体重数。如果您输入的体重在此范围之外，系统将显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til60.png" width="80%" />
              </p>
            </div>
            <p class="m_l_20">
              <i class="allDots back_colorPurple642483 m_r_10"></i>
              <span>
                  <span class="f_w color_793286">FVIII PK输注总剂量 (IU):</span><span>按照国际单位（IU）输入FVIII PK输注总剂量。<br>
                  此应用程序可自动按每公斤体重的IU来计算剂量。</span>
              </span><br>
              <img src="../../assets/til61.png" width="100%" />
            </p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                无法输入低于10 IU/kg或高于100 IU/kg的剂量。如果您输入的剂量在此范围之外，系统将显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til62.png" width="60%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">警告</span><br>
                如果您输入的剂量数值在百因止SPC （20至80 IU/kg）特定范围之外，系统将显示警告消息：<br>
                <img src="../../assets/til63.png" width="60%" />
              </p>
            </div>
            <p class="m_l_20">
              <i class="allDots back_colorPurple642483 m_r_10"></i>
              <span>
                <span class="f_w color_793286">FVIII PK输注日期:</span><span>点击日历以选择FVIII PK输注日期。此区域为必填项目。</span>
              </span>
            </p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                如果您输入的日期之前的输注日期相同，或者将日期编辑为与之前评估相同的日期，您将收到错误消息并且无法用相同的输注日期创建多重评估。<br>
                <img src="../../assets/til64.png" width="80%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                FVIII PK输注日期区域以出生年份为基础。如果您选择的FVIII PK输注日期患者是16岁而且其出生季度并未在一般患者信息特别标出时，会出现如下错误消息，您将无法继续操作：<br>
                <img src="../../assets/til65.png" width="60%" />
              </p>
            </div>
            <p class="m_l_20 m_b_20">
              <i class="allDots back_colorPurple642483 m_r_10"></i>
              <span>
                <span class="f_w color_793286">FVIII PK输注时间:</span><span>按24小时的形式输入时间（小时和分钟）。</span><br>
                也可以点击时钟选择调整时间。<br>
                此区域为必填项目。
              </span><br>
              <img src="../../assets/til66.png" width="100%" /><br>
              <span>点击</span><span class="color_793286">‘保存并进入下一步’</span><span>按钮。</span>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">5.4 之前的PK评估</p>
            <p class="m_b_10">
              <span class="f_w color_793286">myPKFiT</span><span>可以保留患者之前的完整PK评估数据，这些数据可与新数据结合使用，以进行当前的PK评估。当值医生应根据对患者目前状态的了解及对之前评估数据相关性和适宜性的判断，就哪些血液样本和/或之前的PK评估可用于当前评估做出决定。</span>
            </p>
            <p class="m_b_10">
              <span class="f_w color_793286">myPKFiT</span>
              <span>中的每份样本都与其所创建的评估相关联，应根据该评估的背景来解读。每次评估时各位患者特征（体重和年龄）以及剂量和输注前水平都将被保存。</span>
              <span class="f_w color_793286">myPKFiT</span>
              <span>可提供每次评估得出的或多重评估结合得出的个体PK参数。</span>
            </p>
            <p class="m_b_10">
              <span>在此叠放窗口，您可以查看该患者所有之前的PK评估结果。您可以决定是否将每次评估结果包括在当前评估的贝叶斯计算中。默认设置为包括所有的评估结果。如果您包括了上一次的PK评估结果，所有与该次评估相关的样本都会显示在样本图标处。然后点击</span>
              <span class="color_793286">‘下一步’</span>
              <span>以保存您的更改。</span>
            </p>
            <p><img src="../../assets/til67.png" width="100%" /></p>
            <p style="font-style: oblique" class="color_793286 m_b_20">注：当创建第一个评估时，预先评估列表为空。</p>
            <p class="f_w color_blue00458d m_b_10 font16">5.5 样本</p>
            <p>在此部分，您可输入实验室血液样本数据。</p>
            <p class="m_l_20">
              <i class="allDots back_colorPurple642483 m_r_10"></i>
              <span>
                <span class="f_w color_793286">洗脱</span><span>（完整定义请查看术语表）</span>
              </span>
            </p>
            <p class="m_b_10">首先，您需要确定患者在PK评估之前是否已洗脱（即患者在过去48至72小时内没有根据其半衰期进行过FVIII输注，因此患者输注前FVIII水平回到患者正常的内源性FVIII基线处。）洗脱期是指所测出的FVIII水平可低于实验检测的限度或患者FVIII基线，即之前通过FVIII输注的外源性FVIII已在体内存量极少或彻底消失。如欲了解更多信息，请参见如下决策树状图。</p>
            <p class="m_b_10"><img src="../../assets/til68.jpg" width="100%" /></p>
            <p class="m_b_10">
              <span>洗脱值默认为</span><span class="color_793286">‘是’</span><span>。如果您改变此数值为</span><span class="color_793286">‘否’</span><span>，您需要输入输注前FVIII水平。</span>
            </p>
            <p class="m_b_10"><img src="../../assets/til69.png" width="100%" /></p>
            <p style="font-style: oblique" class="color_793286 m_b_10">
              注：如果无输注前FVIII水平，点击‘无此数据’按钮。然后您需要在弹出窗口输入患者最近一次的剂量信息。系统将根据之前的输注剂量信息来估算输注前的（外源性）FVIII水平。<br>
              FVIII输注前水平的信息（无论测定或者估算）将用于确定PK输注时的FVIII基线，还会用于之后PK参数的计算。
            </p>
            <p class="m_b_10"><img src="../../assets/til70.png" width="100%" /></p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                输注前FVIII水平值必须在0至40IU/dL之间。<br>
                如果您输入的数值在此范围之外，会显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til71.png" width="60%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                输注前FVIII水平必须大于等于患者的FVIII基线。<br>
                如果您输入的数值低于患者的FVIII基线，会显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til72.png" width="60%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">警告</span><br>
                如果您输入的输注前FVIII水平高于10 IU/dL且低于或等于40 IU/dL，您将收到警告消息要求您确认输入的数据：<br>
                <img src="../../assets/til73.png" width="60%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                之前的输注日期和时间必须为FVIII PK输注日期和时间的12小时至72小时之间。<br>
                如果洗脱时间大于72小时，请选择洗脱为‘是’。如果您输入的数据在此范围之外，系统将显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til74.png" width="60%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                总FVIII剂量必须在10至100 IU/kg之间。<br>
                如果您输入的之前输注剂量在此范围之外，系统将显示错误消息，您将无法继续操作。<br>
                <img src="../../assets/til75.png" width="60%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">警告</span><br>
                根据百因止SPC，建议的FVIII剂量范围在20至80 IU/kg之间。<br>
                如果您输入的总FVIII剂量导致出来的剂量结果在此范围之外，您将收到警告消息要求您确认输入的数据。<br>
                <img src="../../assets/til76.png" width="60%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">警告</span><br>
                如果计算出的输注前FVIII水平数值高于10 IU/dL，您将收到警告消息要求您确认输入的数据。<br>
                <img src="../../assets/til77.png" width="60%" />
              </p>
            </div>
            <p class="m_l_20">
              <i class="allDots back_colorPurple642483 m_r_10"></i>
              <span>
                <span class="f_w color_793286">添加样本</span>
              </span>
            </p>
            <div style="margin-left: 40px">
              <p>
                <img src="../../assets/til78.png" width="60" /><span>点击</span><span class="color_793286">‘添加样本’</span><span>按钮就会显示一个弹出窗口，包括如下必填区域：</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">采集日期</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">采集时间</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">FVIII水平（IU/dL)</span>
              </p>
              <p class="m_b_10">
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">分析类型 (一步法或显色法)</span>
              </p>
              <p>以下区域为选填项：</p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">样本在定量下限以下（BLQ）</span><span>选项框</span>
              </p>
              <p class="m_b_10">
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">BLQ FVIII水平（IU/dL）</span>
              </p>
              <p class="m_b_10">
                请输入采集数据的日期、时间以及已测定的FVIII水平等所需信息。<br>
                <span>如果测定的FVIII水平低于定量下限（如＜1 IU/dL），请选择下面的定量下限以下（BLQ）选项框。一旦打勾，</span><span class="color_793286">BLQ FVIII水平（IU/dL）</span><span>区域将变为可编辑，您可以在此填写FVIII水平（在此例中为1 IU/dL）。FVIII水平（IU/dL）区域将随之变为灰色并不可填。</span><span class="color_793286">BLQ FVIII水平（IU/dL）</span><span>区域将被默认为灰色。</span>
              </p>
              <p style="font-style: oblique" class="color_793286">注：请参见术语表中BLQ的定义。</p>
            </div>
            <p class="m_b_10"><img src="../../assets/til79.png" width="100%" /></p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                样本采集日期和时间必须为FVIII输注日期和时间之后的10分钟至72小时之间。<br>
                如果您输入的数据在此范围之外，系统将显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til80.png" width="60%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                FVIII水平必须大于或等于患者的FVIII（内源性）基线。<br>
                如果您输入的数值低于患者的（内源性）FVIII基线，会显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til81.png" width="60%" />
              </p>
            </div>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：如果测定的FVIII水平低于FVIII基线，请确认输入的数据。如果输入数据正确，我们建议您调查实验室的化验程序和/或包括抑制剂状态在内的患者临床参数是否有所改变。</p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                输入的FVIII水平无法超过250 IU/dL。高于这个范围意味着超过了临床研究中观察的FVIII水平。<br>
                如果您输入的样本FVIII水平超过此数值，系统将显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til82.png" width="60%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10">
              <p>
                <span class="f_w font16 color_793286">警告</span><br>
                <span class="color_793286 f_w">myPKFiT</span><span>根据群体模型中的FVIII最高观测水平来计算每次输注后每时点处的最高FVIII预期水平。</span><br>
                如果您输入的样本FVIII水平超过此最高预期水平，您将收到警告信息要求您确认输入的数据：<br>
                <img src="../../assets/til83.png" width="60%" />
              </p>
            </div>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：根据输入的数据，FVIII水平（IU/dL）的数值会显示在警告信息的截屏上。</p>
            <div style="border: 1px solid #793286" class="pd_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                BLQ FVIII水平必须比患者（内源性）FVIII基线更高或与之持平。<br>
                如果您输入的数值低于患者的（内源性）FVIII基线，会显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til84.png" width="60%" />
              </p>
            </div>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：如果测定的FVIII水平低于FVIII基线，请确认输入的数据。如果输入数据正确，我们建议您调查实验室的化验程序和/或包括抑制剂状态在内的患者临床参数是否有所改变。</p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                输入的BLQ FVIII水平（IU/dL）的数值必须高于0且低于2 IU/dL。<br>
                如果您输入的BLQ FVIII水平超过此数值，系统将显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til85.png" width="60%" />
              </p>
            </div>
            <p>
              <img src="../../assets/til86.png" width="60" style="vertical-align: bottom"/>
              <span>点击</span><span class="color_793286">‘保存’</span><span>以确认您输入的数值，您可以在窗口顶部看到确认信息：</span>
            </p>
            <p class="m_b_10"><img src="../../assets/til87.png" width="100%" /></p>
            <div style="border: 1px solid #793286" class="pd_10">
              <p class="t_c"><img src="../../assets/til88.png" width="80%" /></p>
              <p>
                如果您输入的样本数据不符合预期标准，如上警告信息会一直显示在窗口顶部。由于此信息表示PK特征曲线可能不准确，您将无法进入PK特征曲线这一步。但是，系统将不会阻止您继续操作。如果选择继续操作，您需要多加注意。
              </p>
            </div>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：请采用准确的采血时间以确保最佳的PK参数计算。在将满足最少数量的FVIII样本用于myPKFiT时，请确保这些样本高于FVIII基线并超过定量下限。</p>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：样本条件可能遮挡部分内容。您可能需要滚动鼠标以查看被遮挡的内容。</p>
            <p>每份样本都需重复此过程。在叠放窗口底部可以看到一些计算数值，如清除率 （dL/hr/kg）、稳定状态的数值（dL/kg）、FVIII半衰期 （小时）和到1%的时间（小时）。</p>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：请参见术语表中对如上名词的定义。</p>
            <p class="m_b_10"><img src="../../assets/til89.png" width="100%" /></p>
            <p class="m_b_10">
              <span>符合最低建议样本标准（即2个或以上样本，一个在输注后3至4小时（± 30分钟）采集，而另一个在输注后24至32小时（± 1小时）采集）时， </span><span class="f_w color_793286">myPKFiT</span>
              <span>根据测定FVIII样本水平来定量校正的FVIII清除率，使用改进的贝叶斯算法来估算个体PK参数并提供剂量指南。还可将改进的贝叶斯算法用于首个样本在输注后2.5小时或更久采集，而第二个样本在第一个样本采集12小时后采集。这时，在建议采样时间条件满足之前会显示警告信息。如果推荐的样本条件未满足，</span>
              <span class="f_w color_793286">myPKFiT</span><span>依然会采用传统方法提供剂量指导，但请谨慎参考此情况下的剂量推荐。</span><br>
              <span>医疗专业人士拥有根据患者病情、个人需要以及之前治疗时的反应来决定计算出的FVIII输注剂量的自由裁量权。</span>
            </p>
            <p class="m_b_10">应用算法（传统的或改进的贝叶斯）的选择显示在含有个体PK参数的估算表下方。请参见术语表以了解改进的贝叶斯算法的更多详细解释。</p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">警告</span><br>
                如果计算数值在此预期群体范围之外，您将收到警告消息要求您确认输入的数据。<br>
                <img src="../../assets/til90.png" width="80%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">警告</span><br>
                如果建议的输注后样本条件未能满足，系统将显示需要注意建议剂量的警告信息直到样本条件被满足。<br>
                <img src="../../assets/til91.png" width="80%" />
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <div>
                <span class="f_w font16 color_793286">警告</span><br>
                如果系统检测出药代动力学特征只达到中度拟合优度，警报信息会要求您确认您输入的数据。请在参考剂量指南时多加注意。<br>
                <img src="../../assets/til92.png" width="80%" class="m_b_20" /><br>
                <p style="font-style: oblique" class="color_793286">注：请参见术语表中对拟合优度的定义。</p>
              </div>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                如果药代动力学特征的拟合优度不被系统接受，系统将显示错误消息，您将无法继续操作：<br>
                <img src="../../assets/til93.png" width="80%" /><br>
              </p>
            </div>
            <p class="m_b_20">
              <img src="../../assets/til94.png" width="50" style="vertical-align: bottom"/><span>您可以在此编辑当前评估的当前样本，从包含在贝叶斯算法的之前的输注评估样本中包含/排除样本（本软件默认值为包含样本，排除样本需要您编辑修改）。然后点击</span><span class="color_793286">‘下一步’</span><span>以保存您的更改。</span><br>
              注：如果您排除了某个样本，该样本会在下次您进行评估时被默认排除。
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">5.6 PK特征曲线</p>
            <p class="m_b_10">PK特征曲线部分根据患者信息及样本数据来显示个体PK计算结果的图表。</p>
            <p class="m_b_10"><img src="../../assets/til95.png" width="100%" /></p>
            <p>
              Y轴（垂直轴）代表因子VIII的水平（％），X轴（水平轴）代表FVIII PK输注后以小时为单位的时间。<br>
              图形将包含如下信息：
            </p>
            <p class="m_b_10">
              <i class="DfiBlue"></i><span class="m_l_10">蓝色钻石是指包括在计算结果中的目前评估样本。</span><br>
              <i class="squareRed"></i><span class="m_l_5">红色方框是指被排除在计算结果之外的目前评估样本。</span><br>
              <i class="triBlue"></i><span class="m_l_5">蓝色三角是指包括以前评估结果中的样本。</span><br>
              <i class="triRed"></i><span class="m_l_5">红色三角是指排除在以前评估结果之外的样本。</span><br>
              <i class="f_w" style="color: blue">—</i><span class="m_l_5">蓝色线代表个体PK特征曲线。</span><br>
              <i>--</i><span class="m_l_5">虚线代表相同年龄、体重、给药剂量的典型患者的预期FVIII活性与时间曲线。</span><br>
              <i class="areaGreen"></i><span class="m_l_5">绿线区域代表PK群体加/减20% </span>
            </p>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：通过在图表下方的图例中取消选择一个或多个项目，您可以将该项目排除显示在图形里。排除的信息就会在图例中变成灰色，而且不会显示在图表中。</p>
            <p class="m_b_10"><img src="../../assets/til96.png" width="100%" /></p>
            <p>当在蓝线和点线悬停时，您可以看到曲线特定点估算的FVIII水平。</p>
            <p class="m_b_10"><img src="../../assets/til97.png" width="40%" /></p>
            <p class="m_b_10">当在目前评估的样本标识处悬停时，您可以看到样本数据（输注后时间和测定的FVIII水平）。</p>
            <p>
              <span>当悬停在以前评估所包括的样本标识时，您可以看到原始数据和调整后样本数据（输注后时间、测定的FVIII水平和调整后的FVIII水平）。仅出于直观显示的目的，如果有以前评估中不同PK输注剂量的样本，</span><span class="f_w color_793286">myPKFiT</span><span>将做出调整使其符合目前的FVIII时间曲线。</span>
            </p>
            <p class="m_b_20">
              <img src="../../assets/til98.png" width="40%" /><br>
              当悬停在以前评估所排除的样本标识时，您可以看到原始样本数据（输注后时间和测定的FVIII水平）。<br>
              <img src="../../assets/til99.png" width="40%" />
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">5.7 剂量计算</p>
            <p class="m_b_10">剂量计算部分说明如何根据之前估计的个体PK参数、所需的剂量间隔及所选的最低FVIII目标谷浓度来制定剂量方案。首先您需要选择在1至20%之间的FVIII目标谷浓度。</p>
            <p class="m_b_10"><img src="../../assets/til100.png" width="100%" /></p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                目标谷浓度必须在1至20%之间。如果您输入的数据在此范围之外，系统将显示错误消息，您将无法查看剂量图表。<br>
                <img src="../../assets/til101.png" width="60%" /><br>
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                如果计算出的剂量在10 IU/kg至100 IU/kg范围之外，您将收到错误信息而无法继续操作。<br>
                <img src="../../assets/til102.png" width="60%" /><br>
              </p>
            </div>
            <p style="font-style: oblique" class="color_793286 m_b_10">
              注：在剂量计算表的IU剂量和IU/kg剂量区域，将用红色高光标出错误信息且不显示剂量数值。<br>
              注：我们建议医生在考虑最适剂量时，特别是当计算剂量在20-80 IU/kg（根据当地批准的处方信息）范围外时自己做出最佳判断。
            </p>
            <p class="m_b_10">目前尚未出现因过量输注引起的副作用。但是，根据以往记载的使用72小时输注间隔的日常高预防剂量百因止的临床经验，我们限定了剂量范围。</p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <div>
                <span class="f_w font16 color_793286">警告</span><br>
                如果按每公斤体重计算出的FVIII剂量在20-80IU/kg范围外而在10-100 IU/kg范围内，您将收到警告消息并提示您做出显示/隐藏计算剂量的选择。<br>
                <img src="../../assets/til103.png" width="80%" class="m_b_10"/><br>
                <img src="../../assets/til104.png" width="100%" class="m_b_10"/><br>
                <p>如果您点击显示计算剂量，将显示出如下信息及给药计划：</p>
                <img src="../../assets/til105.png" width="100%" class="m_b_10"/><br>
                <p>如果您选择不显示计算剂量，将显示如下信息而给药计划为空：</p>
                <img src="../../assets/til106.png" width="100%" class="m_b_10"/><br>
                <p><img src="../../assets/til58.png" width="40" style="vertical-align: bottom"/><span>您可以在此通过点击铅笔图标选择编辑您的显示或者隐藏剂量计算。</span></p>
              </div>
            </div>
            <p style="font-style: oblique" class="color_793286 m_b_10">
              注：在剂量计算表的IU剂量和IU/kg剂量区域，将用黄色高光标出警告数值。
            </p>
            <p class="m_b_10">请注意需要根据当地批准的处方信息来制定百因止的剂量。</p>
            <p><img src="../../assets/til107.png" width="100%"/></p>
            <p>
              当您设定目标谷浓度后，剂量计算图形将显示如下信息：<br>
              <span class="f_w color_793286">图表</span>
            </p>
            <div class="m_l_20 m_b_10">
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">FVIII水平（IU/dL)</span><span>显示在图表的顶部</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>Y轴（垂直轴）显示</span><span class="f_w color_793286">FVIII的水平（％）</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>X轴（水平轴）显示</span><span class="f_w color_793286">给药间隔</span><span>（小时）。</span>
              </p>
              <p class="m_l_20">您可以将时间间隔调整为24、48、72小时，或者从给药间隔选项中选择定制不同的间隔（不可超过72小时）。</p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>蓝色曲线显示预期的</span><span class="f_w color_793286">一周FVIII水平。</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>您可以使用图表两侧的FVIII水平以下的时间点滑块和FVIII水平以上的时间点滑块来突出您的患者在特定FVIII阈值以上或以下的时间。</span>
              </p>
              <div class="m_l_20">
                <p>
                  <i class="allDots back_colorhui m_r_10"></i>
                  <span>绿色阴影区域突出</span><span class="f_w color_793286">特定FVIII百分比以上的时间点</span><span>，您可以选择使用</span><span class="f_w color_793286">在FVIII水平以上的时间点</span><span>滑块。输注后在所选FVIII百分比之上的估计时间将显示在图表下方的表格里。</span>
                </p>
                <p>
                  <i class="allDots back_colorhui m_r_10"></i>
                  <span>红色阴影区域突出</span><span class="f_w color_793286">特定FVIII百分比以下的时间点</span><span>(有出血危险而身体可能有更多活动时，您希望您和您的患者了解的FVIII的最低水平）。您可以通过使用在图表右侧的</span><span class="f_w color_793286">FVIII水平以下的时间点</span><span>滑块来调整这一设置。下一次输注前在所选FVIII百分比之下的估计时间点将显示在图表下方的表格里。</span>
                </p>
              </div>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>在图表下方，您可以看见以IU和IU/kg来显示剂量的</span><span class="f_w color_793286">给药计划表格。</span><span>当您改变目标谷浓度和/或给药间隔时，剂量将被自动调整。</span>
              </p>
            </div>
            <p class="m_b_10"><img src="../../assets/til108.png" width="100%"/></p>
            <p class="m_b_20">
              表格将显示计算出的以IU和IU/kg为单位的一周剂量计划。<br>
              您可以通过使用滑块在每个剂量处看到患者高于和低于所选FVIII百分比的小时数。<br>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">5.7.1 剂量方案模拟</p>
            <p class="m_b_20"><span class="f_w color_793286">myPKFiT</span><span>可为每位患者模拟不同剂量方案，将之保存为不同的PDF文件（参见如下 5.7.2.1节）。</span></p>
            <p class="f_w color_blue00458d m_b_10 font16">5.7.2 给药间隔</p>
            <p class="m_b_10">您可以选择24、48、72小时的标准给药间隔，或者通过点击‘定制’按钮来选择定制给药计划。<br><img src="../../assets/til109.png" width="60%"/></p>
            <p class="m_b_10">一周计划将显示在弹出窗口上。<br><img src="../../assets/til110.png" width="100%"/></p>
            <p class="m_b_10">如果您根据需要选择定制天数来制定给药间隔，注意不要超过前一个所选日期的72小时。您在选择多个输注日期时，注意其中的任何给药间隔不要超过72小时。本应用程序目前仅支持一周的给药计划，因此如果您的给药日期不规则，您需要手动输入给药间隔。例如，如果您以星期一为开始，选择48小时作为输注间隔，那么第二周的开始日期就变为了星期二，因此您需要特别指定（第一周）周日的给药间隔为24小时还是48小时。</p>
            <div style="border: 1px solid #793286" class="pd_10 m_b_10">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                如果您不选择定制给药间隔，就会显示错误消息，您将无法继续操作。<br>
                <img src="../../assets/til111.png" width="100%" /><br>
              </p>
            </div>
            <div style="border: 1px solid #793286" class="pd_10 m_b_20">
              <p>
                <span class="f_w font16 color_793286">错误</span><br>
                如果输入的给药间隔超过72小时，您将收到错误消息，您将无法继续操作。<br>
                <img src="../../assets/til112.png" width="100%" /><br>
              </p>
            </div>
            <p class="f_w color_blue00458d m_b_10 font16">5.7.2.1 生成PDF</p>
            <p class="m_b_20">
              一旦对模拟结果满意，您可以点击按钮将其保存为PDF文件。<br>
              <img src="../../assets/til113.png" width="50%" /><br>
              您可以使用可识别标准PDF格式文件的阅读器查看该PDF文件。
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">5.8 已保存的PDF</p>
            <p class="m_b_20">
              在此部分，您可以查看所有已生成的PDF文件。<br>
              <img src="../../assets/til114.png" width="100%" class="m_t_10"/>
            </p>
            <p style="font-style: oblique" class="color_793286 m_b_10">
              注：<img src="../../assets/til115.png" width="14"/><span>标识用来表示在使用改进的贝叶斯算法（</span><span class="f_w color_793286">myPKFiT</span><span>版本2.0）之前创建的评估 。个别PK估算值和特征曲线可能与用最新/目前版本得到的结果有所不同。点击标识，查看说明文本。</span>
            </p>
            <p class="m_b_10">点击右侧的图标以下载PDF文件。<br><img src="../../assets/til116.png" width="15%"/></p>
            <p>PDF文件包含下列内容：</p>
            <div class="m_l_20 m_b_20">
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>患者信息</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>PK评估信息</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>样本</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>PK特征曲线</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>剂量计算</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>警告（如有）</span>
              </p>
            </div>
          </div>
          <div id="fit06">
            <p class="f_w color_blue00458d m_b_10 font16">6 用户管理</p>
            <p class="f_w m_b_10">本章节仅供担任“医院管理员”的用户阅读。</p>
            <p class="f_w color_blue00458d m_b_10 font16">6.1 概要</p>
            <p class="m_b_20">
              作为医院管理员用户，您有权限管理您医院的用户。<br>
              <span>可以在管理员窗口进行管理。本章节将就如何在</span><span class="f_w color_793286">myPKFiT</span><span>应用程序添加用户、向用户分配职责和任务，以及管理用户账户进行说明。</span>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">6.2 在myPKFiT工具和管理窗口之间转换</p>
            <p class="m_b_10">
              <span>从用户列表窗口，点击左上方的</span><span class="f_w color_793286">myPKFiT</span><span>标识以进入用户控制面板。您还可以点击后退按钮以返回用户控制面板。</span><br>
              <span>从控制面板，点击‘我的患者’图标进入</span><span class="f_w color_793286">myPKFiT</span><span>的患者列表。</span><br>
              <span>从</span><span class="f_w color_793286">myPKFiT</span><span>控制面板，点击管理员面板的</span><span class="color_793286">‘用户’</span><span>图标进入管理的用户列表。</span>
            </p>
            <p class="t_c m_b_20" style="white-space: nowrap">
              <img src="../../assets/til117.jpg" width="40%"/><img src="../../assets/til119.png" width="30"/><img src="../../assets/til118.png" width="40%"/>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">6.3 用户列表</p>
            <p class="m_b_10"><img src="../../assets/til120.png" width="100%"/></p>
            <p>管理员窗口包含如下元素：</p>
            <div class="m_l_20 m_b_10">
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">myPKFiT</span><span>图标：使用这一选项回退到用户控制面板</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">搜索栏：</span><span>使用这一选项输入搜索条件后可以搜索您医院的用户</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">‘添加用户’图标：</span><span>使用此选项将新用户添加到您的医院</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">过滤下拉菜单：</span><span>使用此选项以根据其状态（即已激活、停用或锁定）来过滤您医院的用户</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span class="f_w color_793286">后退按钮：</span><span>使用此按钮以后退至前一步。</span>
              </p>
            </div>
            <p class="m_b_10">
              <span class="color_793286">用户列表</span><br>
              默认用户列表每页显示10个项目。每页的项目数可以用分页下拉菜单来调整。在各页间浏览时，可以使用在列表底部的导航功能。<br>
              <img src="../../assets/til121.png" width="80%"/>
            </p>
            <p>如下用户信息将会显示出来：</p>
            <div class="m_l_20 m_b_10">
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>姓名</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>编码</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>电子邮件地址</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>医院访问等级</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>访问权限等级</span>
              </p>
            </div>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：您可以利用搜索栏或过滤菜单来为信息排序。</p>
            <p class="color_793286">右手边顶部菜单：</p>
            <div class="m_b_20">
              <div class="d_i v_m" style="width: 40%">
                <img src="../../assets/til122.png" width="100%"/>
              </div><div class="d_i v_m m_l_5" style="width: calc(60% - 5px)">
                <p>
                  <i class="allDots back_colorPurple642483 m_r_10"></i>
                  <span>登入此会话的用户姓名</span>
                </p>
                <p>
                  <i class="allDots back_colorPurple642483 m_r_10"></i>
                  <span>账户设置</span>
                </p>
                <p>
                  <i class="allDots back_colorPurple642483 m_r_10"></i>
                  <span>登出使该用户中止操作</span>
                </p>
              </div>
            </div>
            <p class="f_w color_blue00458d m_b_10 font16">6.3.1 搜索用户</p>
            <p class="m_b_20">从搜索栏的“用户列表”类型搜索条件开始搜索用户。您可以搜索任何条件（即名字、中间名、姓氏、电子邮件地址、电话号码、备选电话号码、权限等）。医院中所有符合搜索条件的用户都会显示出来。</p>
            <p class="f_w color_blue00458d m_b_10 font16">6.4 过滤用户</p>
            <p class="m_b_20">在“用户列表”，利用过滤下拉菜单根据用户目前状态来为其排序。在第6.7节对不同的用户状态另有说明。</p>
            <p class="f_w color_blue00458d m_b_10 font16">6.5 创建用户</p>
            <p class="m_b_10">
              <span>在管理员窗口点击</span><span>‘添加用户’。</span><br>
              <img src="../../assets/til123.png" width="50"/>
            </p>
            <p class="m_b_10">
              会出现用户信息窗口。<br>
              <img src="../../assets/til124.png" width="100%"/>
            </p>
            <p>填写需要的信息：</p>
            <p>必填项目：</p>
            <div class="m_l_20">
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>名字</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>姓氏</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>电子邮件地址及确认</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>电话号码</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>语言</span>
              </p>
            </div>
            <p>选填项：</p>
            <div class="m_l_20 m_b_10">
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>中间名</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>称呼</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>备选电话号码</span>
              </p>
            </div>
            <p><span>点击</span><span class="color_793286">‘下一步’。</span><br><img src="../../assets/til125.jpg" width="40"/></p>
            <p class="color_793286 m_b_10">注：所有用户创建窗口都有‘取消’按钮，创建中的用户可以随时被取消。</p>
            <p class="m_b_10">
              本应用程序可以在数据库搜索所提供的电子邮件地址。<br>
              如果电子邮件地址不存在，即可以创建新用户。
            </p>
            <p class="color_793286 m_b_10">注：如果系统中已经存在该电子邮件，您将收到是否希望编辑该现有用户的消息。</p>
            <p class="m_b_10"><img src="../../assets/til126.png" width="100%"/><br>网站访问信息窗口将显示。<br><img src="../../assets/til127.png" width="100%"/></p>
            <p class="m_b_10">
              <span>除了基本的医院访问权限，您可以通过点击</span><span class="color_793286">‘医院用户管理员’</span><span>赋予新用户医院管理员的权限。</span>
            </p>
            <p class="m_b_10">
              点击下一步按钮。<br><img src="../../assets/til125.jpg" width="40"/>
            </p>
            <p>会显示查看患者窗口。<br><img src="../../assets/til128.png" width="100%"/></p>
            <p>在这个窗口，您可以选择新用户的查看权限类型：</p>
            <div class="m_l_20 m_b_10">
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>无法查看患者</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>所有患者</span>
              </p>
              <p>
                <i class="allDots back_colorPurple642483 m_r_10"></i>
                <span>限定的患者</span>
              </p>
            </div>
            <p class="m_b_10">
              默认设置为所有患者。<br>
              <span>如果您选择</span><span class="color_793286">‘限定的患者’</span><span>，将列出该用户可以查看的患者列表。</span><br><img src="../../assets/til129.png" width="100%"/>
            </p>
            <p class="m_b_10">
              <span>点击</span><span class="color_793286">‘添加患者’</span><span>按钮，您可以选择该用户可以查看的个别患者。</span><br>
              <img src="../../assets/til130.png" width="100%"/><br>
              <span>勾选您想要添加的患者的</span><span class="color_793286">‘选择’</span><span>框。</span><br>
              <span>选定后，点击</span><span class="color_793286">‘确认’</span><span>按钮。</span><br>
              <img src="../../assets/til131.jpg" width="40"/><br>
              <img src="../../assets/til132.png" width="100%"/><br>
              <span>如欲从列表中移除某位患者，请点击</span><span class="color_793286">‘移除’</span><span>按钮即可移除该患者。</span><br>
              <span>如欲添加更多患者，请再次点击</span><span class="color_793286">‘添加患者’</span><span>按钮。</span><br>
            </p>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：您在编辑此用户信息时可随时编辑该列表。</p>
            <p class="m_b_10">
              <span>一旦您回到查看患者面板，点击</span><span>‘确认’</span><span>按钮。</span><br><img src="../../assets/til131.jpg" width="40"/><br>
            </p>
            <p style="font-style: oblique" class="color_793286 m_b_10">注：如果您选择了‘医院用户管理员’权限，您将需要输入您的密码以确认所创建的用户。</p>
            <p class="m_b_20"><img src="../../assets/til132.png" width="100%" class="m_b_10"/><br><img src="../../assets/til133.png" width="100%"/><br>您将被带到用户列表，您可以看到已完成创建新用户的确认消息。</p>
            <p class="f_w color_blue00458d m_b_10 font16">6.6 管理已有用户</p>
            <p class="m_b_10">在管理员窗口您可以停用某个用户、编辑用户信息、启用已停用的用户或者重置用户的密码。<br><img src="../../assets/til135.png" width="100%"/></p>
            <p class="f_w color_blue00458d m_b_10 font16">6.7 用户状态</p>
            <p class="m_b_20">
              用户可以有如下状态：<br>
              <span class="color_793286">已激活：</span><span>用户可以访问系统</span><br>
              <span class="color_793286">停用：</span><span>用户的账号用户账号被停用，用户无法访问系统。如果用户在180天之内未访问本应用程序，其状态会自动变为停用。</span><br>
              <span class="color_793286">锁定：</span><span>用户账号被锁定，用户无法访问系统。当用户连续输入5个错误密码或者5次错误安全问题答案时，其状态会自动变为锁定。</span>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">6.7.1 移除用户</p>
            <p class="m_b_10">
              <span>点击</span><span class="color_793286">‘编辑’</span><span>按钮。</span><br><img src="../../assets/til136.png" width="100%"/>
            </p>
            <p class="m_b_10"><span>在用户信息选项卡，点击</span><span class="color_793286">‘移除用户’。</span><br><img src="../../assets/til137.png" width="60"/></p>
            <p class="m_b_10">
              会显示确定移除用户的确认消息。<br><img src="../../assets/til138.png" width="100%"/><br>该用户将不再出现在用户列表。<br>
              如果用户希望再次访问系统，需要创建一个新的账号。
            </p>
            <p style="font-style: oblique" class="color_793286 m_b_20">注：移除某位用户，该用户只是从目前医院被移除。如果用户希望再次访问医院，就需要建立一个新的账号。</p>
            <p class="f_w color_blue00458d m_b_10 font16">6.7.2 停用用户</p>
            <p class="m_b_10">
              如欲停用某用户，只需在其账户状态选项框去除划勾。<br>
              <img src="../../assets/til139.png" width="100%"/><br>
              会出现一个弹出窗口询问您是否想要停用此用户。如果您想要停用该用户，请点击‘确认’按钮。<br>
              <img src="../../assets/til140.png" width="100%"/>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">6.7.3 启用用户</p>
            <p class="m_b_10">
              如欲启用某用户，请在其账户状态选项框划勾。<br>
              <img src="../../assets/til141.png" width="100%"/><br>
              会出现一个确认您想要启用该用户的弹出窗口。如果您想要启用该用户，点击‘确认’按钮。<br>
              <img src="../../assets/til142.png" width="100%"/>
            </p>
            <p class="f_w color_blue00458d m_b_10 font16">6.7.4 重置密码</p>
            <p class="m_b_20">
              <span>如欲解锁某用户，点击</span><span class="color_793286">‘解锁’</span><span>按钮为该‘锁定’用户解锁</span><br>
              <img src="../../assets/til143.png" width="100%"/><br>
              <span>会出现一个确认您想要为该用户解锁的弹出窗口。如果您想要为该用户解锁，点击</span><span class="color_793286">‘确认’</span><span>按钮。</span><br>
              <img src="../../assets/til144.png" width="100%"/>
            </p>
          </div>
          <div id="fit07">
            <p class="f_w color_blue00458d m_b_10 font16">7 警告和错误</p>
            <p class="f_w color_blue00458d m_b_10 font16">7.1 概要</p>
            <p class="m_b_10">
              在本应用程序，警告和错误消息将会以如下形式显示：<br>
              错误消息会在粉色背景文本框里以红色字体显示<br>
              <img src="../../assets/til145.png" width="80%"/>
            </p>
            <p class="m_b_10">
              警告消息会在浅黄色背景文本框里以浅褐色字体显示<br>
              <img src="../../assets/til146.png" width="80%"/>
            </p>
            <p class="m_b_20">请特别注意整个说明书中提到的特定使用点的警告/错误消息以及第7.2节中列出的一般性警告。</p>
            <p class="f_w color_blue00458d m_b_10 font16">7.2 列表</p>
            <table class="proTable m_b_20">
              <thead>
              <tr>
                <th>窗口</th>
                <th>进行的操作</th>
                <th>类型</th>
                <th>消息内容</th>
              </tr>
              </thead>
              <tbody>
              <tr :key="index" v-for="(item, index) in sevenList">
                <td>{{item.mdiBody}}</td>
                <td>{{item.otbody}}</td>
                <td class="f_w" :class="returnBckColor(item.status)"><span :class="returnColor(item.status)">{{item.type}}</span></td>
                <td :class="returnBckColor(item.status)"><span :class="returnColor(item.status)" v-html="item.lmbody"></span></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div id="fit08">
            <p class="f_w color_blue00458d m_b_10 font16">8 标识</p>
            <p class="f_w color_blue00458d m_b_10 font16">8.1 概要</p>
            <p class="m_b_10">该章节将解释本使用说明中的标识。</p>
            <p class="f_w color_blue00458d m_b_10 font16">8.2 在myPKFiT应用程序中使用的标识</p>
            <table class="proTable m_b_20">
              <tbody>
              <tr :key="index" v-for="(item, index) in eightList">
                <td class="t_c">
                  <img :src="item.imgUrl" width="50%">
                </td>
                <td><span v-html="item.body"></span></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div id="fit09">
            <p class="f_w color_blue00458d m_b_10 font16">9 术语表</p>
            <p class="f_w color_blue00458d m_b_10 font16">9.1 概要</p>
            <p class="m_b_10"><span>此章节将说明</span><span class="color_793286 f_w">myPKFiT</span><span>中使用的术语。</span></p>
            <p class="f_w color_blue00458d m_b_10 font16">9.2 本说明中使用的术语</p>
            <table class="proTable m_b_20">
              <tbody>
              <tr :key="index" v-for="(item, index) in nineList">
                <td class="t_c">
                  <span class="color_793286 f_w">{{item.name}}</span>
                </td>
                <td><span v-html="item.body"></span></td>
              </tr>
              </tbody>
            </table>
          </div>
          <div id="fit10">
            <p class="f_w color_blue00458d m_b_10 font16">10 快速参考指南</p>
            <p class="f_w color_blue00458d m_b_10 font16">10.1 概要</p>
            <p class="m_b_10"><span>此章节提供如何使用</span><span class="color_793286 f_w">myPKFiT</span><span>的快速指南。</span></p>
            <p class="f_w color_blue00458d m_b_10 font16">10.2 访问及登入</p>
            <p class="m_b_10"><span>本说明书的第</span><span style="font-style: oblique">2.2 登入</span><span>内有完整内容。</span><br><img src="../../assets/til167.png" width="100%"/></p>
            <p class="f_w color_blue00458d m_b_10 font16">10.3 主控制面板</p>
            <p class="m_b_10"><span>本说明书的第</span><span class="f_w">3 myPKFiT</span><span>控制面板内有完整内容。</span><br><img src="../../assets/til168.png" width="100%"/></p>
            <p class="f_w color_blue00458d m_b_10 font16">10.4 管理患者</p>
            <p class="m_b_10"><span>本说明的第</span><span style="font-style: oblique">4.3管理已有患者（我的患者）</span><span>内有完整内容。</span><br><img src="../../assets/til169.png" width="100%"/></p>
            <p class="f_w color_blue00458d m_b_10 font16">10.5 添加患者</p>
            <p class="m_b_10"><span>本说明的第</span><span style="font-style: oblique">4.2创建新患者</span><span>内有完整内容。</span><br><img src="../../assets/til170.png" width="100%"/></p>
            <p class="f_w color_blue00458d m_b_10 font16">10.6 PK评估</p>
            <p class="m_b_10"><span>本说明的第</span><span style="font-style: oblique">5部分患者评估</span><span>中可以找到完整的信息。</span><br><img src="../../assets/til171.png" width="100%"/></p>
            <p class="f_w color_blue00458d m_b_10 font16">10.7 创建评估</p>
            <p class="m_b_10"><span>本说明的第</span><span style="font-style: oblique">5患者评估</span><span>内有完整内容。</span><br><img src="../../assets/til172.png" width="100%"/></p>
            <p class="m_b_10"><img src="../../assets/til173.png" width="100%"/></p>
            <p class="m_b_10"><img src="../../assets/til174.png" width="100%"/></p>
            <p class="m_b_10"><img src="../../assets/til175.png" width="100%"/></p>
            <p class="m_b_10"><img src="../../assets/til176.png" width="100%"/></p>
            <p class="m_b_10"><img src="../../assets/til177.png" width="100%"/></p>
            <p class="m_b_10"><img src="../../assets/til178.png" width="100%"/></p>
            <p class="m_b_10"><img src="../../assets/til179.png" width="100%"/></p>
          </div>
          <div id="fit11">
            <p class="f_w color_blue00458d m_b_10 font16">11 故障排除及常见问题解答 </p>
            <div class="m_b_20">
              <p class="f_w color_blue00458d m_b_10 font16">11.1 寻求帮助</p>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题1：</span>
                  <div>
                    <span>我如何得到有关</span><span class="color_793286">myPKFiT</span><span>故障的帮助？</span>
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    <span>您可以在登入后通过点击主控制面板上的图标或者在本应用程序内任何页面的底部点击</span><span class="color_793286">“帮助及常见问题解答”</span><span>链接，以访问“帮助及常见问题解答”部分。</span>
                  </div>
                </div>
                <div class="leR">
                  <span>答案2：</span>
                  <div>
                    <span>请参见</span><span class="color_793286">myPKFiT</span><span>使用说明以了解更多操作说明。</span>
                  </div>
                </div>
              </div>
              <div>
                <div class="leR f_w">
                  <span>问题2：</span>
                  <div>
                    <span>我如何报告</span><span class="color_793286">myPKFiT</span><span>应用程序的问题？</span>
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    <span>在应用程序底部，您可以点击</span><span class="color_793286">“联系我们”</span><span>链接找到您当地Baxalta办事处的联系信息。</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="m_b_20">
              <p class="f_w color_blue00458d m_b_10 font16">11.2 访问问题</p>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题1：</span>
                  <div>
                    <span>我为何无法登入</span><span class="color_793286">myPKFiT</span><span>应用程序？</span>
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    您的互联网没有连接好。试试您知道的经常更新的网站，如新闻网站。如果您无法访问那个网站，或者那个网站看起来没有更新，这就说明您的互联网连接有问题。请联系您的IT部门寻求帮助。
                  </div>
                </div>
                <div class="leR">
                  <span>答案2：</span>
                  <div>
                    <span>您也可能输入了错误的</span><span class="color_793286">myPKFiT</span><span>程序的URL。请确认您输入的www.mypkfit.cn是否正确。如果这样还无法访问，请联系您当地的Baxalta联络点。</span>
                  </div>
                </div>
                <div class="leR">
                  <span>答案3：</span>
                  <div>
                    <span>您可能没有</span><span class="color_793286">myPKFiT</span><span>账号。与您的医院管理员联系并确认您有相关账号。</span>
                  </div>
                </div>
                <div class="leR">
                  <span>答案4：</span>
                  <div>
                    <span>您可能输入了错误的登入ID。您的登陆账号是您注册的邮箱。请再次输入您的登入ID。如果您仍无法访问</span><span class="color_793286">myPKFiT</span><span>程序，请联系您的医院管理员。</span>
                  </div>
                </div>
                <div class="leR">
                  <span>答案5：</span>
                  <div>
                    <span>您可能输入了错误的密码。如果您忘记了您的密码，点击</span><span class="color_793286">“忘记密码”</span><span>链接，然后请按照说明操作。尝试5次失败后，您的账号将会被锁定。如果您的账号被锁定，请联系您的医院管理员以重设密码。新的密码必须符合如下条件： </span><br>
                    <div>
                      <p>
                        <i class="allDots back_colorPurple642483 m_r_10"></i>
                        <span>至少有8个字母与数字字符</span>
                      </p>
                      <p>
                        <i class="allDots back_colorPurple642483 m_r_10"></i>
                        <span>至少包含1个数字</span>
                      </p>
                      <p>
                        <i class="allDots back_colorPurple642483 m_r_10"></i>
                        <span>至少包含1个字母</span>
                      </p>
                      <p>
                        <i class="allDots back_colorPurple642483 m_r_10"></i>
                        <span>不可与前4个密码相同</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div class="leR f_w">
                  <span>问题2：</span>
                  <div>
                    <span>为何</span><span class="color_793286">myPKFiT</span><span>应用程序无法识别我的账号？</span>
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    您的账号已被停用，因为该账号已有180天以上未被使用。<br>
                    请联系您的医院管理员重新启用您的账号。
                  </div>
                </div>
                <div class="leR">
                  <span>答案2：</span>
                  <div>
                    您的账号未激活，因为该账号已有270天未被使用。请联系俄您的医院管理员重新激活您的账号。
                  </div>
                </div>
              </div>
            </div>
            <div class="m_b_20">
              <p class="f_w color_blue00458d m_b_10 font16">11.3 患者管理问题</p>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题1：</span>
                  <div>
                    我在哪儿可以查看患者信息？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    <span>点击控制面板上的</span><span class="color_793286">“我的患者”</span><span>图标。就会出现可以查看和搜索患者的窗口。</span>
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题2：</span>
                  <div>
                    我如何停用某位患者？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    <span>到“我的患者”</span><span class="color_793286">点击</span><span>“ 激活”图标。您将被要求确认是否需要停用该患者。</span>
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题3：</span>
                  <div>
                    我错误地停用了某位患者。我怎么改正这个错误呢？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    <span>在“我的患者”点击</span><span class="color_793286">“ 过滤”。</span><span>您可以回到“未激活”选项以查看被停用的患者。未激活的患者将被显示会灰色。只需点击</span><span class="color_793286">“ 未激活”</span><span>图标便可重新激活该患者。</span>
                  </div>
                </div>
              </div>
              <div>
                <div class="leR f_w">
                  <span>问题4：</span>
                  <div>
                    我需要更改患者信息。我应该如何做？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    <span>如果您需要更改信息（患者识别号、出生年度等）您可以点击</span><span class="color_793286">“患者ID”</span><span>然后点击铅笔图标。您还可以点击“患者信息”顶部的铅笔图标来更改评估内的患者信息。</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="m_b_20">
              <p class="f_w color_blue00458d m_b_10 font16">11.4 评估管理问题</p>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题1：</span>
                  <div>
                    我在哪儿查看评估信息？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    在“我的患者”点击某位患者信息旁边的听诊器图标就可以查看所选患者以往所有的评估结果。
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题2：</span>
                  <div>
                    我如何创建新的评估？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    有两种创建新评估的方法；<br>
                    I.  当创建患者时，会弹出一个窗口，询问您是否创建新评估<br>
                    II. 在评估列表，点击显示在“PK评估”表格右上角的听诊器加号图标。
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题3：</span>
                  <div>
                    我错误地创建了一个评估，导致现在无法创建新的评估。我该怎么做？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    您无法在已有评估结果的输注日期再创建新评估。您无法在同一输液日期创建一个以上的评估。如果您错误地创建了评估，您可以将已存在的评估更改为正确的日期。
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题4：</span>
                  <div>
                    为什么 我在输入体重时总会出现弹出消息？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    <span>本程序仅为体重在45至120 kg的患者设计。如果患者的体重低于或高于这些参数，您将无法继续操作。另外，</span><span class="color_793286">myPKFiT</span><span>基于体重范围在11 kg至108 kg患者的模型，因此如果您的患者体重在此范围之外 （但在5至120 kg之间），PK特征曲线的结果可能会不够准确。您还是可以继续进行，但是需要多加注意。</span>
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题5：</span>
                  <div>
                    当我输入PK输注总剂量时 为何总是出现弹出窗口？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    每千克体重的剂量必须在10至100 IU之间，否则您将无法继续操作。如果剂量在10-100 IU/kg 之内但在推荐的20-80 IU/kg以外<参见当地批准的ADVATE说明书>，您仍然可以进行下一步但应谨慎进行。
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题6：</span>
                  <div>
                    当我添加一份样本时为何在窗口上方会出现一个消息？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    当添加样本时，您需要确保样本符合如下条件以求系统能给出最准确答案：<br>
                    您需要至少添加2份样本：一个在输液后3到4小时（± 30分钟）之间采集，另一个在24至32小时（± 1小时）之间采集。因子VIII的水平应该在每个后续样本中有所减少。<br>
                    如果您的样本不符合所规定的条件，该消息就会出现在评估过程中，而且作为警告包括在PDF内。
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题7：</span>
                  <div>
                    PK特征曲线图表中的线条都代表什么？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    蓝色线代表根据患者的年龄、体重以及输入的样本数据得出的个体估算PK特征曲线曲线。<br>
                    黑色点线代表与临床研究群体相比以患者年龄、体重范围为基础的群体PK曲线。<br>
                    绿色区域代表患者群体平均值加/减20%之间的范围，您患者的PK曲线通常在这个范围内。
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题8：</span>
                  <div>
                    以前评估的样本数据为何在PK特征曲线图表内被调整？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    由于个体FVIII活性及时间曲线有赖于FVIII输注总剂量，之前不同FVIII PK输注剂量的评估样本需要进行调整以确保可以正确地体现在当前评估中。
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题9：</span>
                  <div>
                    我在剂量计算处看不到任何信息。这是什么原因？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    为了查看剂量信息图表，您必须首先在适当区域输入目标谷值水平。一旦您输入某个数值（1至20%），剂量图表就会自动显示出来。
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题10：</span>
                  <div>
                    在剂量计算中的滑块代表什么？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    左边的滑块用来查看特定FVIII水平以上的小时数。滑块上的最小数值可设定在10%，最大数值即为FVIII水平的最高值。右边的滑块用来查看特定FVIII水平以下的小时数。滑块上的最小数值可设定在目标谷水平以上基线％减去1，最大数值为20%。在某FVIII水平以上的时间点对应的剂量与其以下的时间点对应的剂量之间的小时数将显示在图表底部的表格里。
                  </div>
                </div>
              </div>
              <div class="m_b_10">
                <div class="leR f_w">
                  <span>问题11：</span>
                  <div>
                    当我选择定制天数时为什么会有选择间隔的选项？
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    设置该选项是因为您选择的剂量模型有可能在周与周之间产生不同的结果。例如，第1周的间隔为48小时：星期一、星期三、星期五、星期日；第2周：星期二、星期四、星期六等。由于本程序只支持1周剂量计划，您需要在该周的最后一天输入给药间隔，这样本程序可以在最后一天正确地计算剂量。
                  </div>
                </div>
              </div>
              <div>
                <div class="leR f_w">
                  <span>问题12：</span>
                  <div>
                    <span class="color_793286">myPKFiT</span><span>版本1的算法与改进算法有何不同？</span>
                  </div>
                </div>
                <div class="leR">
                  <span>答案1：</span>
                  <div>
                    <span>改进的</span><span class="f_w">myPKFiT</span><span>算法通过对患者FVIII表观消除率的初步评估来确保使用该患者合适的贝叶斯先验数据。在传统贝叶斯检测方法运用之前，如果患者的活性时间数据显示适合，经预设步骤获得的消除率经验预估值将暂时用于完善贝叶斯先验数据以完成一次数据运算。</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="fit12">
            <p class="f_w color_blue00458d m_b_10 font16">12 索引</p>
            <p>
              <img src="../../assets/til180.png" width="100%"/><br>
              <img src="../../assets/til181.png" width="100%"/><br>
              <img src="../../assets/til182.png" width="100%"/><br>
              <img src="../../assets/til183.png" width="100%"/>
            </p>
          </div>
          <div style="margin-top: 100px">
            <p class="m_b_10">本文件之前的版本（如有）</p>
            <table class="proTable1">
              <thead>
              <tr>
                <th>软件版本</th>
                <th>发布日期</th>
                <th>文件编号/修订</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>版本2.0</td>
                <td>2017年01 月</td>
                <td>VV-00922318-v1.0</td>
              </tr>
              <tr>
                <td>版本2.0</td>
                <td>2017年02 月</td>
                <td>VV-00922318-v2.0</td>
              </tr>
              <tr>
                <td>版本2.0.11</td>
                <td>2020年12 月</td>
                <td>VV-00922318-v3.0</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div style="margin-top: 100px">
            <p class="m_b_10">
              <span class="f_w">百深、百因止</span><span>及</span><span class="f_w color_793286">myPKFiT</span><span>为百深有限公司（ Baxalta Incorporated）的注册商标。其他在此出现的商标、产品品牌或图像属于其各自的所有者。</span>
            </p>
            <p class="m_b_10">
              如丢失本文件或本文件有损坏，请联系百深并提及文件号码VV-00922318修订3.0以索要新的副本。
            </p>
            <p>
              百深版权所有，并保留解释权。
            </p>
          </div>
        </div>
      </div>
      <!--百因止-->
      <div v-if="selProd === 2">
        <div class="allProBody p_r">
          <p class="f_w t_c m_b_10 font16">注射用重组人凝血因子Ⅷ说明书</p>
          <p class="m_b_20 t_c">请仔细阅读说明书并在医师指导下使用</p>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【药品名称】</p>
            <p class="m_b_10 text_in">通用名称:注射用重组人凝血因子Ⅷ</p>
            <p class="m_b_10 text_in">商品名称:百因止 ADVATE</p>
            <p class="m_b_10 text_in">英文名称: Recombinant Human Coagulation Factor Ⅷ For Injection</p>
            <p class="text_in">汉语拼音: Zhusheyong Chongzu Ren Ning Xue Yin Zi Ba</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【成份】</p>
            <p class="m_b_10 text_in">本品为采用基因重组技术以中国仓鼠卵巢细胞生产的重组人凝血因子Ⅷ</p>
            <p class="m_b_10 text_in">活性成分:重组人凝血因子Ⅷ</p>
            <p class="m_b_10 text_in">冻干粉辅料:甘露醇、氯化钠、组氨酸、海藻糖、氯化钙、三羟甲基氨基甲烷、聚山梨醇酯80、谷胱甘肽</p>
            <p class="text_in">稀释液:灭菌注射用水</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【性状】</p>
            <p class="m_b_10 text_in">注射用粉末和溶剂</p>
            <p class="m_b_10 text_in">冻干粉:本品为白色或淡黄色疏松体</p>
            <p class="m_b_10 text_in">溶剂:灭菌注射用水为无色澄明液体,无臭</p>
            <p class="text_in">按标示量加入本品所附的灭菌注射用水,配置后溶液应为澄明、无色、无异物的溶液</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【适应症】</p>
            <p class="m_b_10 text_in">本品适用于血友病A(先天性凝血因子Ⅷ缺乏)患者出血的治疗和预防</p>
            <p class="text_in">本品不含具有药效作用剂量的 von Willebrand因子,因此不适用于血管性血友病</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【规格】</p>
            <p class="text_in">250IU/瓶;500IU/瓶;1000IU/瓶;1500IU/瓶</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【用法用量】</p>
            <p class="m_b_10 text_in">本品应在有治疗血友病经验的医生指导下使用。出现速发型超敏反应时,能立即获得复 苏支持</p>
            <p class="f_w m_b_10 text_in">给药剂量</p>
            <p class="m_b_10 text_in">使用本品替代治疗的剂量和持续时间取决于凝血因子Ⅷ缺乏的严重程度、出血部位、范围以及患者的临床情况</p>
            <p class="m_b_10 text_in">以国际单位IU标示本品重组人凝血因子Ⅷ的效价。血浆中凝血因子Ⅷ活性以IU或者百分数(相对于正常人血浆)来表示</p>
            <p class="m_b_10 text_in">1个IU本品重组凝血因子Ⅷ的活性等效于1ml正常人血浆中的凝血因子Ⅷ</p>
            <p class="m_b_10 text_in f_w">按需治疗：</p>
            <p class="m_b_10 text_in">根据经验计算按需治疗所需剂量,即,给予每kg体重1IU的本品可以使血浆凝血因子Ⅷ活性提高2IU/dl。所需剂量按以下公式计算</p>
            <p class="m_b_10 text_in">治疗所需本品剂量(IU)=体重(kg)×预期的因子Ⅷ升高值(IU/dl 或 %)×0.5</p>
            <p class="m_b_10 text_in">当发生表1中所列出血事件时,相应时期因子Ⅷ活性不应低于给定的血浆活性水平(IU/dl或%)。下表1可用于出血和外科手术时指导给药剂量。</p>
            <table class="proTable1 m_b_10">
              <thead>
              <tr>
                <th colspan="3" class="t_c f_w">表1 控制出血和围手术期给药剂量的指南</th>
              </tr>
              </thead>
              <tbody>
              <tr class="f_w">
                <td>出血程度/手术操作类型</td>
                <td>需要达到的凝血因子Ⅷ水平 （IU/dl 或％） </td>
                <td>给药频率（小时V治疗持续时间（天）</td>
              </tr>
              <tr>
                <td>
                  <p class="m_b_10">出血</p>
                  <p class="m_b_10">早期关节积血、肌肉出血或口腔出血</p>
                  <p class="m_b_10">较广泛的关节积血、肌肉出血或血肿形成</p>
                  <p>危及生命的出血</p>
                </td>
                <td class="t_c">
                  <p class="m_b_10">20〜40</p>
                  <p class="m_b_10">30〜60</p>
                  <p>60〜100</p>
                </td>
                <td>
                  多次静脉输注，每12〜24小时1次（6 岁以下的患者每8〜24小时1次），至少1天，直到出血停止（可表现为疼痛减轻）或创面愈合。<br>
                  多次静脉输注，每12〜24小时1次（6 岁以下的患者每8〜24小时1次），至少3〜4天，直到疼痛和急性活动障碍消失。<br>
                  多次静脉输注，每8〜24小时进行1次（6岁以下的患者每6〜12小时1次），直到出血停止，不再有生命危险。
                </td>
              </tr>
              <tr>
                <td>
                  <p class="m_b_10 f_w">手术</p>
                  <p class="m_b_10">小手术（包括拔牙）</p>
                  <p>大手术</p>
                </td>
                <td class="t_c">
                  <p class="m_b_10">20〜40</p>
                  <p>80 〜100<br>（术前和术后）</p>
                </td>
                <td>
                  每24小时1次静脉输注，（6岁以下的 患者每12〜24小时1次），至少1天， 直到出血停止或创面愈合。<br>
                  多次静脉输注，每8〜24小时1次（6 岁以下的患者每6〜24小时1次），直 到创口已经充分愈合，然后再继续给 药至少7天，使凝血因子Ⅷ的活性维 持在30%〜60% （IU/dl）。
                </td>
              </tr>
              </tbody>
            </table>
            <p class="m_b_10 text_in">应根据个体对治疗的临床反应来调整给药的剂量和频率。在某些情况下(如出现低滴度制物),可能需要使用比上述公式计算所得结果更大的剂量</p>
            <p class="m_b_10 text_in">在治疗期间,建议适当检测血浆凝血因子Ⅷ水平以指导给药的剂量和重复注射的频率。尤其在实施大手术的情况下,必须通过测定血浆凝血因子Ⅷ的活性来对替代治疗进行准确的监测。由于存在个体间差异,本品在不同患者体内的回收率和半衰期可能会不同。</p>
            <p class="m_b_10 text_in f_w">预防用药:</p>
            <p class="m_b_10 text_in">对于严重血友病A患者出血的长期预防,常规剂量为每kg体重20~40IU,给药间隔为2〜3天。</p>
            <p class="m_b_10 text_in f_w">儿童用药:</p>
            <p class="m_b_10 text_in">对于按需治疗,儿童患者(0〜18岁)的剂量与成年患者并无不同。对于6岁以下的患者,推荐采用20~50IU因子Ⅷ每kg体重、每周3~4次进行预防性治疗</p>
            <p class="m_b_10 text_in f_w">给药方法:</p>
            <p class="m_b_10 text_in">本品应通过静脉给药。如为非专业医务人员给药,需要进行适当的培训</p>
            <p class="m_b_10 text_in">给药速率的确定以使患者舒适为宜,最快不应超过10ml/分钟</p>
            <p class="m_b_10 text_in">配制后,应为澄清、无色、不含异物的溶液,pH为6.7至7.3</p>
            <p class="m_b_10 text_in">每次给药后,均应登记产品的名称及批号。给药前按照所附说明配制本品</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w" style="text-decoration: underline">本品的使用说明</p>
            <p class="m_b_10 text_in">本品使用所附的冻干粉及5ml灭菌注射用水配制后，即可经静脉给药。</p>
            <p class="m_b_10 text_in">应目检配制后溶液是否有任何异物和/或变色。不得使用浑浊、或有沉淀的溶液。</p>
            <p class="m_b_10 text_in">给药时必须使用带有鲁尔接头的注射器。同时，必须使用塑料注射器，因为本品中的蛋白质成分易与玻璃注射器的表面发生粘附。</p>
            <p class="m_b_10 text_in">-本品配制后，应在3小时内使用。</p>
            <p class="m_b_10 text_in">-本品配制后不得冷冻。</p>
            <p class="m_b_10 text_in">-根据地方要求处置任何未使用的产品或废弃物。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【不良反应】</p>
            <p class="m_b_10">1.安全性概述</p>
            <p class="m_b_10 text_in">418位受试者参与了本品的临床研究并至少暴露一次，共报告93例药物不良反应（ADR）。发生频率最高的药物不良反应包括产生因子Ⅷ中和抗体（抑制物）、头痛和发热。</p>
            <p class="m_b_10 text_in">超敏反应（过敏反应）包括血管性水肿、输注部位灼痛和刺痛、寒战、潮红、全身性荨麻疹、头痛、荨麻疹、低血压、困倦、恶心、躁动、心动过速、胸闷、刺痛感、呕吐、哮鸣，在某些病例中可发展为严重的速发型超敏反应（包括休克）。</p>
            <p class="m_b_10 text_in">可观察到患者对小鼠和/或仓鼠蛋白产生抗体并伴相关超敏反应。</p>
            <p class="m_b_20 text_in">血友病A患者可能产生因子Ⅷ的中和抗体（抑制物）。出现这类抑制物时，可能表现为临床止血效果不佳。在这种情况下，建议联系专门的血友病中心。</p>
            <p class="m_b_10">2.不良反应分析</p>
            <p class="m_b_10 text_in">本品在国外临床试验中和上市后自发报告中患者发生不良反应及频率见下表2。该表根据MedDRA的系统器官分类（SOC与首选术语级别）编制。</p>
            <p class="m_b_10 text_in">根据以下定义发生频率：十分常见（≥1/10）、常见（≥1/100,<1/10）、偶见（≥1/1000,<1/100）、罕见（≥1/10000,<1/1000）、十分罕见（<1/10000）,不确定（无法从现有数据估算）。在发生频率组内，以严重程度降序排列下列不良反应。</p>
            <table class="proTable1 m_b_10">
              <thead>
              <tr>
                <th colspan="3" class="t_c f_w">表2 临床试验中和上市后自发报告的不良反应及频率</th>
              </tr>
              </thead>
              <tbody>
              <tr class="f_w">
                <td>MedDRA标准系统器官分类</td>
                <td>不良反应</td>
                <td style="white-space: nowrap">频率<sup>a</sup></td>
              </tr>
              <tr>
                <td rowspan="2">感染及侵染类疾病</td>
                <td class="t_c">流感</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">喉炎</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td rowspan="2">血液及淋巴系统疾病</td>
                <td class="t_c">因子VIII抑制物<sup>c</sup></td>
                <td class="t_c">常见</td>
              </tr>
              <tr>
                <td class="t_c">淋巴管炎</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td rowspan="2">免疫系统疾病</td>
                <td class="t_c">速发型超敏反应</td>
                <td class="t_c">不确定</td>
              </tr>
              <tr>
                <td class="t_c">超敏反应</td>
                <td class="t_c">不确定</td>
              </tr>
              <tr>
                <td rowspan="7">神经系统疾病</td>
                <td class="t_c">头痛</td>
                <td class="t_c">常见</td>
              </tr>
              <tr>
                <td class="t_c">头晕</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">记忆损害</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">晕厥</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">震颤</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">偏头痛</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">味觉障碍</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td>眼器官疾病</td>
                <td class="t_c">眼炎症</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td>心脏器官疾病</td>
                <td class="t_c">心悸</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td rowspan="3">血管与淋巴管类疾病</td>
                <td class="t_c">血肿</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">潮热</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">苍白</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td>呼吸系统、胸及纵隔疾病</td>
                <td class="t_c">呼吸困难</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td rowspan="4">胃肠系统疾病</td>
                <td class="t_c">腹泻</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">上腹痛</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">恶心</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">呕吐</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td rowspan="4">皮肤和皮下组织类疾病</td>
                <td class="t_c">瘙痒</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">皮疹</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">多汗</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">荨麻疹</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td rowspan="10">全身性疾病和给药部位各种反应</td>
                <td class="t_c">发烧</td>
                <td class="t_c">常见</td>
              </tr>
              <tr>
                <td class="t_c">外周水肿</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">胸痛</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">胸部不适</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">寒战</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">感觉异常</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">血管穿刺部位血肿</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">疲乏</td>
                <td class="t_c">不确定</td>
              </tr>
              <tr>
                <td class="t_c">注射部位局部反应</td>
                <td class="t_c">不确定</td>
              </tr>
              <tr>
                <td class="t_c">不适</td>
                <td class="t_c">不适</td>
              </tr>
              <tr>
                <td rowspan="4">检查</td>
                <td class="t_c">单核细胞计数升高</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">凝血因子VIII浓度降低<sup>b</sup></td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">血细胞容积减低</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">实验室检查异常</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td rowspan="3">损伤、中毒和操作并发症 </td>
                <td class="t_c">操作后并发症</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">操作后出血</td>
                <td class="t_c">偶见</td>
              </tr>
              <tr>
                <td class="t_c">操作部位反应</td>
                <td class="t_c">偶见</td>
              </tr>
              </tbody>
            </table>
            <p class="m_b_10 text_in"></p>
            <p class="m_b_10 text_in">注：</p>
            <p class="m_b_10 text_in">a） 根据本品治疗患者总数（418例）计算的患者百分比。</p>
            <p class="m_b_10 text_in">b） 1例患者在手术后（手术后10〜14天）持续输注本品期间中出现了因子Ⅷ水平非预期降低。本阶段始终维持止血措施，术后15天血浆因子Ⅷ水平和清除率均恢复至适当水平。持续输注结束后和研宄终止时进行的因子Ⅷ抑制物检测为阴性。</p>
            <p class="m_b_20 text_in">C） 第3节中解释的药物不良反应。</p>
            <p class="m_b_10">3.特别关注的不良反应</p>
            <p class="m_b_10 f_w" style="font-style: oblique;text-decoration: underline">因子Ⅷ抑制物的形成</p>
            <p class="m_b_10 text_in">
              <span>既往接受过治疗的患者（PTP）和既往未接受过治疗的患者（PUP）均有产生抑制物的报道。详情请参见</span><span style="font-style: oblique;text-decoration: underline">注意事项</span>。
            </p>
            <p class="m_b_10 f_w" style="font-style: oblique;text-decoration: underline">制造工艺残留物的特定不良反应(ADR)</p>
            <p class="m_b_10 text_in">在229例经治疗后接受中国仓鼠卵巢（CHO）细胞抗体评估的患者中，3例表现出滴度统计学显著上升趋势，4例显示持续峰值或瞬时尖峰，1例患者两种现象均有，但无临床症状。在229例经治疗后接受鼠IgG抗体评估的患者中，10例表现出统计学显著上升趋势，2例显示持续峰值或瞬时尖峰，1例两种现象均有。4例患者在反复暴露于本研究期间报告了荨麻疹、瘙痒、皮疹和嗜酸性粒细胞计数轻度升高的独立事件。</p>
            <p class="m_b_10 f_w" style="font-style: oblique;text-decoration: underline">超敏反应</p>
            <p class="m_b_20 text_in">包括速发型超敏反应和表现出头晕、感觉错乱、皮疹、潮红、面肿、荨麻疹和瘙痒的症状。</p>
            <p class="m_b_10">4.儿童</p>
            <p class="m_b_10 text_in">除了先前未接受过治疗的儿童患者（PUP）形成抑制物以及导管相关并发症，临床研究中未见年龄特异性不良反应差异。</p>
            <p class="m_b_10" style="text-decoration: underline">疑似不良反应报告</p>
            <p class="m_b_10 text_in">药品上市之后，报告疑似不良反应可以帮助连续监控药品的获益/风险平衡。医疗专业人员应按国家规定报告任何疑似不良反应。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【禁忌】</p>
            <p class="text_in">对本品活性成份或对任何辅料过敏/超敏，对小鼠或仓鼠蛋白有过敏/超敏反应者。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【注意事项】</p>
            <p class="m_b_10">1. 超敏反应</p>
            <p class="m_b_10 text_in">本品应在有治疗血友病经验的医生指导下使用，根据医生指导准备相应的复苏措施，以应对可能出现的速发型超敏反应。</p>
            <p class="m_b_10 text_in">本品已有超敏反应（包括速发型超敏反应）的报告。</p>
            <p class="m_b_10 text_in">本品含有痕量的小鼠和仓鼠蛋白。如果出现超敏反应症状，应建议患者立即停止使用本品，并联系医生。</p>
            <p class="m_b_20 text_in">应告知患者超敏反应的早期征兆，包括荨麻疹、全身性荨麻疹、胸闷、哮鸣、低血压和速发型超敏反应。如果发生休克，应执行针对休克的标准治疗。</p>
            <p class="m_b_10">2. 因子Ⅷ抑制物产生</p>
            <p class="m_b_10 text_in">因子Ⅷ中和抗体（抑制物）的产生是血友病A患者治疗中的己知并发症。这些抑制物通常是直接针对因子Ⅷ促凝活性的IgG,使用改良Bethesda法检测，单位为Bethesda单位（BU）/ml血浆。产生因子Ⅷ抑制物的患者可能表现为临床疗效不佳。在这种情况下，建议联系专门的血友病中心。产生抑制物的风险与暴露于因子VO的程度以及其他遗传和环境因素有关，前20个暴露日内的风险最高，100个暴露日以后极少产生抑制物。</p>
            <p class="m_b_10 text_in">己在之前治疗超过100暴露日且有抑制物产生史的患者中观察到在因子Ⅷ产品替换使用后会重新出现抑制物的情况（低滴度）。因此，在改变治疗产品时，建议仔细监测所有患者的抑制物出现情况。</p>
            <p class="m_b_20 text_in">一般而言，应通过适当的临床观察和实验室检测，密切监测接受因子Ⅷ治疗的患者的抑制物产生。若患者接受治疗后达不到预期的因子Ⅷ血浆活性水平，或者在适当剂量下出血不受控制，应进行检测以确定是否存在因子Ⅷ抑制物。在具有高滴度抑制物的患者中，因子Ⅷ替代疗法可能无效，应考虑其他的治疗方法。这类患者的管理应在具有血友病和因子Ⅷ抑制物治疗经验的医师指导下进行。</p>
            <p class="m_b_10">3. 与导管有关的并发症</p>
            <p class="m_b_20 text_in">若患者需要使用中心静脉留置装置（CVAD）,应考虑可能与本品有关的并发症风险，包括局部感染、菌血症以及导管部位血栓。</p>
            <p class="m_b_10">4. 与辅料有关的考虑</p>
            <p class="m_b_10 text_in">本品配制后每瓶含0.45 mmol钠（10mg）,限钠饮食患者应予以考虑。</p>
            <p class="m_b_20 text_in">强烈建议每次给患者使用本品时，记录本品名称和批号，以维持患者和该批次药品之间的联系。</p>
            <p class="m_b_10">5. 由于缺乏相容性研究，本品不得与其他药用产品或溶剂混合使用。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【孕妇及哺乳期妇女用药】</p>
            <p class="text_in">尚未进行因子Ⅷ的动物生殖研究。由于女性罕有血友病A，尚无妊娠和哺乳期使用因子Ⅷ经验。因此，妊娠和哺乳期患者仅在病情明确地显示需要因子Ⅷ治疗时使用。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【对驾驶及操作机械的影响】</p>
            <p class="text_in">本品对驾驶及操作机械的能力没有影响。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【儿童用药】</p>
            <p class="text_in">治疗和预防用量请参照【用法用量】项下内容。上述列出的注意事项也均适用。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【老年用药】</p>
            <p class="text_in">本品临床研究65岁及以上老年患者数据有限，所以尚未确定老年患者使用本品的临床反应是否与年轻受试者相同。因此对老年患者应进行个体化剂量确定。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【药物相互作用】</p>
            <p class="text_in">目前尚未进行本品与其它产品的相互作用研究。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【药物过量】</p>
            <p class="text_in">目前尚无使用本品药物过量症状的报道。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【临床试验】</p>
            <p class="text_in">本品在国外进行的临床试验结果：</p>
            <p class="m_b_10">1. 安全性和有效性研究</p>
            <p class="m_b_10 text_in">根据本品治疗单次新出血事件的止血效果进行总体疗效评估，评分依次分为很好、好、
              一般或无效。共报告510起出血事件，每个受试者平均出血（±SD）为6.1土8.2次。经本
              品治疗的这510起新出血事件中，治疗反应被评为很好和好的有439起（86%）, —般的有
              61起（12%）,无反应为1起（0.2%）,治疗反应不确定的为9起（2%）。总共有411起（81%）
              的新出血事件采用一次输注本品即可成功止血，62起（12%）需要2次输注，15起（3%）
              需要3次输注，22起（4%）需要4次或更多次输注本品才能达到满意的止血效果。总共有
              162起（32%）的新出血事件为自发发生，228起（45%）为外伤的结果，120起（24%）出血事件的原因不明。
            </p>
            <p class="m_b_10 text_in">按方案规定的75个暴露日的预防治疗方案（≥25IU/kg体重，每周3〜4次）中，107例可评价的受试者（n=274起新出血事件）根据出血原因列出的新出血事件发生率如下表3所示。</p>
            <table class="proTable1">
              <thead>
              <tr>
                <th colspan="2" class="t_c f_w">表3 预防治疗中的新出血事件发生率</th>
              </tr>
              </thead>
              <tbody>
              <tr class="f_w">
                <td class="t_c">出血事件病因</td>
                <td class="t_c">每例受试者每月发生新出血事件的平均值（土SD）</td>
              </tr>
              <tr>
                <td class="t_c">自发</td>
                <td class="t_c">0.34 ± 0.49</td>
              </tr>
              <tr>
                <td class="t_c">创伤后</td>
                <td class="t_c">0.39 ± 0. 46</td>
              </tr>
              <tr>
                <td class="t_c">未知<sup>a</sup></td>
                <td class="t_c">0.33 ± 0. 34</td>
              </tr>
              <tr>
                <td class="t_c">总体</td>
                <td class="t_c">0.52 ± 0.71</td>
              </tr>
              </tbody>
            </table>
            <p class="m_b_10 text_in">注：a原因不确定。</p>
            <p class="m_b_10 text_in">出血事件后，经分析，结果显示出血总发生率与规定的预防治疗方案的依从性呈负相关。
              输注剂量小于每kg体重25IU的次数超过总预防输注次数的20%、或每周输注次数少于3
              次的情况超过总研究周数（37周）的20%的患者与那些依从性较好、给药剂量和次数都能
              达到或超过规定的预防治疗方案80%的患者相比，出血事件的发生率要高出2.3倍。考虑到
              非随机性的比较，需谨慎解释这些数据。
            </p>
            <p class="m_b_10">2. 长期研宄</p>
            <p class="m_b_10 text_in">
              更多的安全性和有效性数据来自于参加临床试验后继续进行治疗的患者。一项研究依照
              本品预防给药的剂量至少暴露50天，对82例受试者中的27例进行了中期分析。使用本品
              治疗新出血事件根据止血情况将治疗结果分为很好、好、一般或无效。27例受试者中有13
              例出现了51起出血事件。53%出血事件的发生原因为外伤，27%为自发发生；其它20%则
              未确定。63%的反应情况为很好或好。86%出血事件采用一次输注即可，另外6%需要2次。
              因此92%的出血事件仅需要输注本品1次或2次。比较了62例受试者在治疗开始时以及75
              个暴露日后的体内因子Ⅷ体内回收率。治疗开始时的体内回收率与≥75个暴露日后的体内
              回收率相比无显著性差异。
            </p>
            <p class="m_b_10">3. 围手术期治疗研宄</p>
            <p class="m_b_10 text_in">
              在一项围手术期本品止血有效性的临床研究中，对计划25例受试者中的10例进行了中
              期分析。该10例受试者接受10项外科手术的同时使用本品。其中8例受试者间歇性输注本
              品，2例受试者为持续性加间歇输注。6项外科手术为大手术，4项为小手术。这6项大手
              术中有5项为血友病骨科并发症。每项外科手术的简要描述、研究持续时间和研究药物用量
              见下表4。
            </p>
            <table class="proTable1">
              <thead>
              <tr>
                <th colspan="4" class="t_c f_w">表4 外科手术、研究持续时间和药物用量一览表</th>
              </tr>
              </thead>
              <tbody>
              <tr class="f_w">
                <td class="t_c">手术类型</td>
                <td class="t_c">研宄天数</td>
                <td class="t_c">百因止暴露天数</td>
                <td class="t_c">累计百因止暴露（IU）</td>
              </tr>
              <tr>
                <td class="t_c">全髋关节置换术</td>
                <td class="t_c">16</td>
                <td class="t_c">15</td>
                <td class="t_c">61600</td>
              </tr>
              <tr>
                <td class="t_c">膝关节置换术</td>
                <td class="t_c">22</td>
                <td class="t_c">18</td>
                <td class="t_c">76060</td>
              </tr>
              <tr>
                <td class="t_c">膝关节融合术</td>
                <td class="t_c">24</td>
                <td class="t_c">22</td>
                <td class="t_c">66080</td>
              </tr>
              <tr>
                <td class="t_c">左尺神经移位术</td>
                <td class="t_c">5</td>
                <td class="t_c">3</td>
                <td class="t_c">14560</td>
              </tr>
              <tr>
                <td class="t_c">植入Mediport（中央端口）</td>
                <td class="t_c">28</td>
                <td class="t_c">8<sup>a</sup></td>
                <td class="t_c">46893</td>
              </tr>
              <tr>
                <td class="t_c">牙科拔除</td>
                <td class="t_c">18</td>
                <td class="t_c">6</td>
                <td class="t_c">16599</td>
              </tr>
              <tr>
                <td class="t_c">左肘滑膜切除术</td>
                <td class="t_c">43</td>
                <td class="t_c">32</td>
                <td class="t_c">102180</td>
              </tr>
              <tr>
                <td class="t_c">牙齿拔除</td>
                <td class="t_c">2</td>
                <td class="t_c">2</td>
                <td class="t_c">10350</td>
              </tr>
              <tr>
                <td class="t_c">右膝关节镜检查，软骨成 形术以及滑膜切除术</td>
                <td class="t_c">13</td>
                <td class="t_c">10<sup>a</sup></td>
                <td class="t_c">32334</td>
              </tr>
              <tr>
                <td class="t_c">拔除智齿</td>
                <td class="t_c">14</td>
                <td class="t_c">5</td>
                <td class="t_c">15357</td>
              </tr>
              </tbody>
            </table>
            <p class="m_b_10 text_in">注a:术后前48小时本品持续输注给药，之后治疗使用推注给药。</p>
            <p class="m_b_10 text_in">10例受试者均分别由研宄者对本品在术中和术后的止血效果进行评估，评分为很好、
              好、一般或无效。对每例患者采用同样的评定量表来评价手术切口部位所放置引流管的出血
              情况。所有评估结果均显示本品的止血效果为“很好”或“好”。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【药理毒理】</p>
            <p class="m_b_10">药理作用</p>
            <p class="m_b_10 text_in">本品含重组凝血因子Ⅷ（辛凝血素a）,它是一种与在人血浆中发现的因子Ⅷ糖蛋白生物等效的糖蛋白。</p>
            <p class="m_b_10 text_in">
              因子Ⅷ/von Willebrand复合物包括两种具有不同生理功能的分子（因子VID和von Willebrand因子）。辛凝血素a是一种含有2332种氨基酸的糖蛋白，分子量约为280 kD。当
              输注给血友病患者时，辛凝血素a与患者循环中的内源性von Willebrand因子结合。活化的
              因子Ⅷ作为活化的因子IX的辅助因子，加速因子X转化为活化的因子X。活化的因子X使
              凝血酶原转化为凝血酶。凝血酶使纤维蛋白原转化为纤维蛋白，形成凝块。血友病A是一
              种性连锁染色体遗传性凝血障碍，由因子Ⅷ活性水平降低引起，并导致大量血液流入关节、
              肌肉或内脏器官，可为自发性或由意外或外科创伤而引起。替代治疗可增加血浆因子Ⅷ水平，
              从而暂时纠正因子Ⅷ缺乏并纠正出血倾向。
            </p>
            <p class="m_b_10">毒理研宄</p>
            <p class="m_b_10 text_in">
              单次给予小鼠、大鼠、兔和犬高于临床推荐剂量数倍的本品（根据体重），未见任何急
              性毒性或其它毒性反应。本品未进行重复给药研究，可参考本品相关产品（RECOMBINATE）
              及本品制剂缓冲液（FORMULATION BUFFERS）的毒性试验信息。RECOMBINATE在犬2周毒
              性试验中，观察到贫血，活化部分凝血活酶时间（APTT）延长，白细胞计数下降，（rAHF,
              pdAHF和HSA）抗体生成。在4周毒性试验中，观察到（rAHF, pdAHF和HSA）抗体生成，
              未出现贫血和白细胞计数下降。本品制剂缓冲液在大鼠给药剂量达最高剂量40mg/kg/day
              时，连续30天，未观察到任何毒性反应。
            </p>
            <p class="m_b_10 text_in">
              致癌、致突变、致畸：RECOMBINATE进行了高于血浆浓度的体外致突变研宄和体内给
              药10倍于临床预期剂量的致突变研究，结果显示无任何可逆的突变，无染色体异常或骨髓
              多染性红细胞微核形成增加。未进行动物致癌性试验研究。
            </p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【药代动力学】</p>
            <p class="m_b_10 text_in">
              所有应用本品的药代动力学研宄，都是针对患有重度或中度血友病A的先前接受过
              治疗的患者（基线因子Ⅷ ≤ 2%）进行的。血浆样品的分析在中央实验室用一期凝固分
              析法进行。
            </p>
            <p class="m_b_10 text_in">
              总共195份符合重度血友病A （基线因子Ⅷ ≤ 1%）的样本提供的药代动力学参数
              均包含在基于方案药代动力学的分析集中。对这些分析按婴儿（年龄1个月~2岁）、儿童
              （年龄2岁~5岁）、大龄儿童（年龄5岁~12岁）、青少年（年龄12岁~18岁）、成人
              （年龄18岁及以上）的分类方法进行分类，用于总结药代动力学参数。此处的年龄定义
              为接受PK输注的年龄。
            </p>
            <p class="m_b_10"><img src="../../assets/til184.png" width="100%"/><br><img src="../../assets/til185.png" width="100%"/></p>
            <p class="m_b_10 text_in">
              儿童患者使用本品的安全性和止血功效与成人患者相似。年幼儿童(低于6岁)校正后
              的体内因子Ⅷ活性回收率和终末半衰期(tl/2)比成人约低20%,可能是由于己知儿童患者
              每公斤体重的血浆容积值较高。
            </p>
            <p class="m_b_10 text_in">
              目前尚无本品在既往未接受治疗患者(PUP)中的药代动力学数据。
            </p>
            <p class="m_b_10 text_in">
              在中国患者人群中进行了药代动力学相关临床研究，共分析了符合方案计划分析群的
              22名患者(6名患者小于6岁，5名患者为6~12岁，11名患者为大于12岁)，采用一期凝
              固分析法测定，并采用可用的群体药代动力学模型对比了本品在中国和非中国患者中的药代
              动力学特征，最终结果显示，使用本品的共22名中国患者未出现与非中国患者不同的药代
              动力学特征。
            </p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【贮藏】</p>
            <p class="m_b_10 text_in">贮于冰箱冷藏室2°C〜8°C。</p>
            <p class="m_b_10 text_in">不得冷冻。</p>
            <p class="m_b_10 text_in">将药瓶置于外包装盒内，以免其受到光照。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【包装】</p>
            <p class="m_b_10 text_in">直接接触药品的包装材料为：I型玻璃瓶，丁基胶塞。</p>
            <p class="m_b_10 text_in">每个包装中含有一瓶冻干粉，一瓶5ml灭菌注射用水，一个一次性无针配药器 (BAXJECTII)(己获得进口医疗器械注册证)。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【有效期】</p>
            <p class="m_b_10 text_in">24个月。</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【执行标准】</p>
            <p class="m_b_10 text_in">JS20150036</p>
            <p class="m_b_10 f_w">【进口药品注册证号】</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 f_w">【生产企业】</p>
            <p class="m_b_10 text_in">持证商名称：Baxter AG, Industriestrasse 67, A-1221 Vienna, Austria</p>
            <p class="m_b_10 text_in">生产企业名称：Baxalta Manufacturing Sarl</p>
            <p class="m_b_10 text_in">生产地 址：Route de Pierre-a-Bot 111, 2000 Neuchatel, Switzerland</p>
          </div>
          <div class="m_b_20">
            <p class="m_b_10 text_in">在中国境内销售的产品请按下列地址联系:</p>
            <p class="m_b_10 text_in">百深生物科技（上海）有限公司</p>
            <p class="m_b_10 text_in">地 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;址: 上海市静安区南京西路1717号8楼808室</p>
            <p class="m_b_10 text_in">邮政编码: 200040</p>
            <p class="m_b_10 text_in">电 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;话: 021-22852000</p>
            <p class="m_b_10 text_in">传 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;真: 021-22852196</p>
          </div>
        </div>
      </div>
    </div>
    <div class="dowDiv" @click="upDown()" style="display: none"><img src="../../assets/dl.png" width="20" height="20"></div>
    <!-- iframe -->
    <div v-if="false">
      <iframe :src="iframeUrl" frameborder="0" style="width: 100%;"></iframe>
    </div>
    <agreeBookDialog :ABDialogShow="ABDialogShow" :openId="openId" @ABDialogShowFn="ABDialogShowFn"></agreeBookDialog>
  </div>
</template>

<script>
import agreeBookDialog from "../login/agreeBookDialog";
import merge from 'webpack-merge';
export default {
  name: 'myInstructionBook',
  data () {
    return {
      selProd: 1,
      ABDialogShow:false,
      showMenu: false,
      bookMenu: [
        {
          id: 1,
          name: '简介',
          divID: 'fit01'
        },
        {
          id: 2,
          name: '登入/登出',
          divID: 'fit02'
        },
        {
          id: 3,
          name: 'myPKFiT控制面板',
          divID: 'fit03'
        },
        {
          id: 4,
          name: '患者管理',
          divID: 'fit04'
        },
        {
          id: 5,
          name: '患者评估',
          divID: 'fit05'
        },
        {
          id: 6,
          name: '用户管理',
          divID: 'fit06'
        },
        {
          id: 7,
          name: '警告和错误',
          divID: 'fit07'
        },
        {
          id: 8,
          name: '标识',
          divID: 'fit08'
        },
        {
          id: 9,
          name: '术语表',
          divID: 'fit09'
        },
        {
          id: 10,
          name: '快速参考指南',
          divID: 'fit10'
        },
        {
          id: 11,
          name: '故障排除及常见问题解答',
          divID: 'fit11'
        },
        {
          id: 12,
          name: '索引',
          divID: 'fit12'
        }
      ],
      seltMenuID: 0,
      sevenList: [
        {
          id: 1,
          mdiBody: '登入',
          otbody: '错误/无效的登入',
          type: '错误',
          lmbody: '邮件地址或密码错误。请重试。如果您忘记了密码，请点击“忘记密码”链接。',
          status: 1
        },
        {
          id: 2,
          mdiBody: '创建患者',
          otbody: '填写医院患者ID',
          type: '警告',
          lmbody: '医生通过接受隐私声明来确认他或她已知晓在增加患者页面，完成“患者ID”字段，目的只是形成医院的患者清单，不可用于存储患者的个人信息。',
          status: 2
        },
        {
          id: 3,
          mdiBody: '创建患者',
          otbody: '填写患者出生年份',
          type: '警告',
          lmbody: 'PK模型基于年龄在1至66岁的患者而定。',
          status: 2
        },
        {
          id: 4,
          mdiBody: '编辑患者或评估',
          otbody: '两名用户同时输入了同一位患者的数据。',
          type: '错误',
          lmbody: '其他用户同时更新了该患者的信息。您需要刷新该患者信息以查看最近的更新。',
          status: 1
        },
        {
          id: 5,
          mdiBody: '编辑患者',
          otbody: '编辑已有的患者信息。',
          type: '弹出消息',
          lmbody: '如果您继续编辑该患者信息，任何未保存的数据将会丢失。',
          status: 3
        },
        {
          id: 6,
          mdiBody: '编辑患者',
          otbody: '编辑已有患者的FVIII基线',
          type: '弹出消息',
          lmbody: '您已更改了FⅧ基线。所有在基线下的样本值会在以后的计算中被剔除。请确认数据。您确定保存吗？ ',
          status: 3
        },
        {
          id: 7,
          mdiBody: '编辑患者',
          otbody: '将已有患者的出生季度更改为空白',
          type: '错误',
          lmbody: '一项或多项以前PK评估的患者年龄为16岁。对于16岁的患者其出生季度为必填项目。',
          status: 1
        },
        {
          id: 8,
          mdiBody: '一般性PK评估信息',
          otbody: '输入的体重数值为小数点后一位以上的数字',
          type: '错误',
          lmbody: '该区域只能填写小数点后一位以内的数字。不可填写非数字字符。',
          status: 1
        },
        {
          id: 9,
          mdiBody: '一般性PK评估信息',
          otbody: '输入的体重数值在5至120kg范围之外',
          type: '错误',
          lmbody: '体重必须在45至120kg范围内。',
          status: 1
        },
        {
          id: 10,
          mdiBody: '一般性PK评估信息',
          otbody: '输入的剂量有小数点或非数字字符',
          type: '错误',
          lmbody: '仅可输入数字。不含小数点或非数字符。',
          status: 1
        },
        {
          id: 11,
          mdiBody: '一般性PK评估信息',
          otbody: '输入的剂量在规定的范围之外',
          type: '错误',
          lmbody: '剂量必须介于10 to 100 IU/kg 。推荐的剂量范围是20 - 80 IU/kg(参见百因止SPC) ',
          status: 1
        },
        {
          id: 12,
          mdiBody: '一般性PK评估信息',
          otbody: '输入的剂量在规定的范围之外',
          type: '警告',
          lmbody: '计算得到的FⅧ的【插入FⅧ的PK输注剂量（参见3.9部分）】IU/kg体重剂量超出了20 – 80 IU/kg 范围（参见<本地批准的百因止处方信息>）',
          status: 2
        },
        {
          id: 13,
          mdiBody: '一般性PK评估信息',
          otbody: '为17岁以下患者进行FVIII PK输注时未指明其出生季度',
          type: '错误',
          lmbody: '此次PK评估的患者年龄为16岁。对于16岁的患者其出生季度为必填项目。',
          status: 1
        },
        {
          id: 14,
          mdiBody: '一般性PK评估信息',
          otbody: '编辑FVIII PK输注日期使之前的输注剂量和样本仍然有效',
          type: '弹出消息',
          lmbody: '您更新了FⅧ的PK输注日期/时间。请核对本次PK评估的样本采集和前次输注的日期时间。',
          status: 3
        },
        {
          id: 15,
          mdiBody: '一般性PK评估信息',
          otbody: '编辑FVIII PK输注日期使之前的输注剂量和样本无效',
          type: '弹出消息',
          lmbody: `您更新了FⅧ的PK输注日期/时间。此更新将造成本次PK评估样本采集日期/时间以及前次输注无效。请选择如下之一：<br>－为新一次输注创建新的PK评估<br>－继续修正当前的PK评估`,
          status: 3
        },
        {
          id: 16,
          mdiBody: '一般性PK评估信息',
          otbody: '根据FVIII PK输注的修正日期选择继续修正当前的PK评估',
          type: '弹出消息',
          lmbody: `如果您继续修正当前的PK评估，所有的样本和前次输注的信息将被删除。<br>—删除样本和此次PK评估的前次输注。`,
          status: 3
        },
        {
          id: 17,
          mdiBody: '样本',
          otbody: '需要至少2个可测样本',
          type: '错误',
          lmbody: `推荐的输注后样本条件：<br>·至少需要2个可测样本：第1个在输注后3-4小时（±30分钟），第2个在输注后24-32小时（±1小时）<br>·同一评估的样本FVIII水平应按时间降序排列。`,
          status: 1
        },
        {
          id: 18,
          mdiBody: '样本',
          otbody: '输入输注前FVIII水平',
          type: '警告',
          lmbody: '输注前FⅧ水平(IU/dL)应在10IU/dL以上，请确认。',
          status: 2
        },
        {
          id: 19,
          mdiBody: '样本',
          otbody: '输入的输注前FVIII水平数值为小数点后一位以上的数字',
          type: '错误',
          lmbody: '该区域只能填写小数点后一位以内的数字。不可填写非数字符号。',
          status: 1
        },
        {
          id: 20,
          mdiBody: '样本',
          otbody: '输入输注前FVIII水平',
          type: '错误',
          lmbody: '输注前FⅧ水平(IU/dL)应在0-40IU/dL。',
          status: 1
        },
        {
          id: 21,
          mdiBody: '样本',
          otbody: '输入输注前FVIII水平',
          type: '警告',
          lmbody: '输注前FVIII水平（IU/dL）不可低于患者的FVIII基线。',
          status: 2
        },
        {
          id: 22,
          mdiBody: '样本',
          otbody: '输入之前的输注剂量',
          type: '警告',
          lmbody: '计算得到的FⅧ的IU/kg体重剂量超出了推荐的20 – 80 IU/kg 范围（参见<本地批准的百因止处方信息>），请确认此剂量是否正确。[仅可输入数字-无小数点或非数字符号]',
          status: 2
        },
        {
          id: 23,
          mdiBody: '样本',
          otbody: '输入的之前输注剂量带有小数点或非数字字符',
          type: '错误',
          lmbody: '仅可输入数字-无小数点或非数字符号',
          status: 1
        },
        {
          id: 24,
          mdiBody: '样本',
          otbody: '输入之前的输注剂量',
          type: '错误',
          lmbody: '剂量应在10至100 IU/kg。推荐的剂量范围是20 – 80 IU/kg（参见<本地批准的百因止处方信息>）',
          status: 1
        },
        {
          id: 25,
          mdiBody: '样本',
          otbody: '输入之前的输注剂量',
          type: '错误',
          lmbody: '上一次输注必须为FVIII PK输注日期之前的12小时至72小时之间。',
          status: 1
        },
        {
          id: 26,
          mdiBody: '样本',
          otbody: '输入之前的输注剂量',
          type: '警告',
          lmbody: '计算得到的输注前FⅧ水平IU/dL应大于10IU/dL，请确认输注前的输入值。',
          status: 2
        },
        {
          id: 27,
          mdiBody: '样本',
          otbody: '输入样本的FVIII水平 ',
          type: '警告',
          lmbody: 'FⅧ水平超过了在此时间点所预期的输注后最大IU/dL值，请确认数值输入是否正确。',
          status: 2
        },
        {
          id: 28,
          mdiBody: '样本',
          otbody: '输入的样本FVIII水平是小数点后面一位以上的数字',
          type: '错误',
          lmbody: '此字段只可输入数字并可保留一位小数。不可输入非数字符号。',
          status: 1
        },
        {
          id: 29,
          mdiBody: '样本',
          otbody: '输入样本的FVIII水平',
          type: '错误',
          lmbody: 'FVIII水平不可超过250 IU/dL：请确认输入的数据。',
          status: 1
        },
        {
          id: 30,
          mdiBody: '样本',
          otbody: '输入样本的FVIII水平',
          type: '错误',
          lmbody: '输入的FVIII水平数值不可低于患者的FVIII基线。',
          status: 1
        },
        {
          id: 31,
          mdiBody: '样本',
          otbody: '输入样本的日期和时间',
          type: '错误',
          lmbody: '之前的输注必须在PK输注日期的12小时至72小时之间',
          status: 1
        },
        {
          id: 32,
          mdiBody: '样本',
          otbody: '输入样本的日期和时间',
          type: '错误',
          lmbody: '样本采集日期和时间必须为FVIII输注日期和时间之后的10分钟至72小时之间。',
          status: 1
        },
        {
          id: 33,
          mdiBody: '样本',
          otbody: '输入BLQ FVIII水平',
          type: '错误',
          lmbody: 'BLQ FⅧ水平（IU/dL）必须>0且≤2 IU/dL。',
          status: 1
        },
        {
          id: 34,
          mdiBody: '样本',
          otbody: '输入BLQ FVIII水平',
          type: '错误',
          lmbody: '此字段只可输入数字并可保留三位小数。不可输入非数字符号。',
          status: 1
        },
        {
          id: 35,
          mdiBody: '样本',
          otbody: '包括低于患者FVIII基线的旧样本',
          type: '弹出消息',
          lmbody: '不可包含低于患者FVIII基线的样本。',
          status: 3
        },
        {
          id: 36,
          mdiBody: 'PK特征曲线',
          otbody: 'PK特征曲线',
          type: '警告',
          lmbody: '结果显示只有一个中度拟合优度药代动力学特征曲线。请确认输入的数据，在使用剂量指南多加注意。',
          status: 2
        },
        {
          id: 37,
          mdiBody: 'PK特征曲线',
          otbody: 'PK特征曲线',
          type: '错误',
          lmbody: '不接受此药代动力学特征的拟合优度曲线。无法计算药代动力学曲线和剂量。',
          status: 1
        },
        {
          id: 38,
          mdiBody: 'PK特征曲线',
          otbody: 'PK特征曲线',
          type: '警告',
          lmbody: '样本不能充分满足改进的贝叶斯算法的最佳使用条件。请在使用剂量指南时多加注意。推荐样本的使用是为了更好地利用改进的剂量指南。',
          status: 2
        },
        {
          id: 39,
          mdiBody: 'PK特征曲线',
          otbody: 'PK特征曲线',
          type: '警告',
          lmbody: `预测的FⅧ清除率是超出群体清除率的95%区间。<br>半衰期是基于群体95%区间以外的清除值计算而来的。<br>请在进行下一步之前确认您输入的数值。`,
          status: 2
        },
        {
          id: 40,
          mdiBody: 'PK特征曲线',
          otbody: 'PK特征曲线',
          type: '警告',
          lmbody: `预测的稳态FⅧ数量是群体稳态的数值的95%区间以外。<br>半衰期是基于群体稳态95%区间以外的数值计算而来的。<br>请在进行下一步之前确认您输入的数值。`,
          status: 2
        },
        {
          id: 41,
          mdiBody: 'PK特征曲线',
          otbody: 'PK特征曲线（未满6岁的患者）',
          type: '警告',
          lmbody: '预期FVIII半衰期在群体半衰期（7至15小时）范围之外。请在进行下一步之前确认您输入的数值。',
          status: 2
        },
        {
          id: 42,
          mdiBody: 'PK特征曲线',
          otbody: 'PK特征曲线（已满6岁但未满16岁的患者）',
          type: '警告',
          lmbody: '预期FVIII半衰期在群体半衰期（7至23小时）范围之外。请在进行下一步之前确认您输入的数值。',
          status: 2
        },
        {
          id: 43,
          mdiBody: 'PK特征曲线',
          otbody: 'PK特征曲线（已满16岁的患者）',
          type: '警告',
          lmbody: '预期FVIII半衰期在总体半衰期（7至24小时）范围之外。请在进行下一步之前确认您输入的数值。',
          status: 2
        },
        {
          id: 44,
          mdiBody: '剂量计算',
          otbody: '输入的目标谷浓度带有小数点或者非数字字符',
          type: '错误',
          lmbody: '仅可输入数字—无小数点或非数字符号。',
          status: 1
        },
        {
          id: 45,
          mdiBody: '剂量计算',
          otbody: '输入目标谷浓度水平',
          type: '错误',
          lmbody: '目标谷浓度必须在1至20%之间。',
          status: 1
        },
        {
          id: 46,
          mdiBody: '剂量计算',
          otbody: '设置给药间隔',
          type: '错误',
          lmbody: '超出10 IU/kg 至 100 IU/kg时无法计算剂量。',
          status: 1
        },
        {
          id: 47,
          mdiBody: '剂量计算',
          otbody: '设置给药间隔',
          type: '弹出消息',
          lmbody: '请选择您是否希望显示计算后的剂量值，如果此值超出20-80 IU/kg 范围，但仍在10-100 IU/kg 范围内（参见百因止SPC）',
          status: 3
        },
        {
          id: 48,
          mdiBody: '剂量计算',
          otbody: '设置给药间隔',
          type: '弹出消息',
          lmbody: '您已选择显示计算的剂量值，此值超出20-80 IU/kg范围，但仍在10-100 IU/kg范围内（参见百因止SPC）',
          status: 3
        },
        {
          id: 49,
          mdiBody: '剂量计算',
          otbody: '设置给药间隔',
          type: '弹出消息',
          lmbody: '您已选择隐藏计算的剂量值，此值超出20-80 IU/kg 范围，但仍在10-100 IU/kg 范围内（参见百因止SPC）',
          status: 3
        },
        {
          id: 50,
          mdiBody: '剂量计算',
          otbody: '设置给药间隔',
          type: '警告',
          lmbody: '计算得到的FⅧ每公斤体重剂量值超出了20-80 IU/kg范围（参见<当地批准的百因止处方信息>），但仍在最大范围值 10-100 IU/kg 之内。',
          status: 2
        },
        {
          id: 51,
          mdiBody: '剂量计算',
          otbody: '设置定制的给药间隔',
          type: '错误',
          lmbody: '需至少选择一天。',
          status: 1
        },
        {
          id: 52,
          mdiBody: '剂量计算',
          otbody: '设置定制的给药间隔',
          type: '错误',
          lmbody: '获批准的百因止SPC不支持72小时以上的给药间隔。',
          status: 1
        }
      ],
      eightList: [
        {
          id: 1,
          imgUrl: require('../../assets/til131.jpg'),
          body: '这个标识用于确认您希望进行某特定操作。'
        },
        {
          id: 2,
          imgUrl: require('../../assets/til147.png'),
          body: '这个标识用于取消某特定操作。'
        },
        {
          id: 3,
          imgUrl: require('../../assets/til148.png'),
          body: '这个标识用于返回上一页'
        },
        {
          id: 4,
          imgUrl: require('../../assets/til51.png'),
          body: '点击这个标识以创建患者。'
        },
        {
          id: 5,
          imgUrl: require('../../assets/til149.png'),
          body: '点击这个标识以查看“我的患者”视窗。'
        },
        {
          id: 6,
          imgUrl: require('../../assets/til150.png'),
          body: '这个标识代表已激活的患者。'
        },
        {
          id: 7,
          imgUrl: require('../../assets/til151.jpg'),
          body: '这个标识代表被停用的患者。'
        },
        {
          id: 8,
          imgUrl: require('../../assets/til152.png'),
          body: '这个标识意味着该数值已被选择或选项为激活状态。'
        },
        {
          id: 9,
          imgUrl: require('../../assets/til153.png'),
          body: '选项未被激活或数值未被选择。'
        },
        {
          id: 10,
          imgUrl: require('../../assets/til58.png'),
          body: '编辑已有信息。例如，编辑患者信息。'
        },
        {
          id: 11,
          imgUrl: require('../../assets/til154.png'),
          body: '点击这个标识以查看患者的PK评估。'
        },
        {
          id: 12,
          imgUrl: require('../../assets/til155.png'),
          body: '点击这个标识以添加PK评估。'
        },
        {
          id: 13,
          imgUrl: require('../../assets/til156.png'),
          body: '点击这个标识以查看已保存的PDF。'
        },
        {
          id: 14,
          imgUrl: require('../../assets/til157.png'),
          body: '点击这个标识以打开PDF文件。'
        },
        {
          id: 15,
          imgUrl: require('../../assets/til158.png'),
          body: '在PK特征曲线中，这个标识代表包括在内的患者样本数据。'
        },
        {
          id: 16,
          imgUrl: require('../../assets/til159.png'),
          body: '在PK特征曲线中，这个标识代表被排除的患者样本数据。'
        },
        {
          id: 17,
          imgUrl: require('../../assets/til160.png'),
          body: '在PK特征曲线中，这个标识代表以前评估中包含的患者样本数据。'
        },
        {
          id: 18,
          imgUrl: require('../../assets/til161.png'),
          body: '在PK特征曲线中，这个标识代表以前评估中被排除的患者样本数据。'
        },
        {
          id: 19,
          imgUrl: require('../../assets/til162.png'),
          body: '在PK特征曲线中，蓝色曲线代表个体PK特征曲线。'
        },
        {
          id: 20,
          imgUrl: require('../../assets/til163.png'),
          body: '在PK特征曲线中，黑色虚线代表PK群体。'
        },
        {
          id: 21,
          imgUrl: require('../../assets/til164.png'),
          body: '在PK特征曲线中，图表中的绿色区域代表PK群体± 20%。'
        },
        {
          id: 22,
          imgUrl: require('../../assets/til165.png'),
          body: `<span>点击</span><span class="color_793286">‘提交’</span><span>之后，当有未填的或填写无效的必填信息时会出现错误消息图标。您必须先提供未填的信息再保存。</span>`
        },
        {
          id: 23,
          imgUrl: require('../../assets/til166.png'),
          body: `<span>点击</span><span class="color_793286">‘提交’</span><span>之后，若所有必填信息都填写正确会出现填写成功消息图标。</span>`
        },
        {
          id: 24,
          imgUrl: require('../../assets/til115.png'),
          body: '点击此标识以打开说明文本。'
        }
      ],
      nineList: [
        {
          id: 1,
          name: '评估',
          body: `<span class="color_793286 f_w">myPKFiT</span><span>的PK评估是一次基于个体PK参数确定剂量方案的尝试。每个PK评估与单次FⅧ输注相关，并与输注前和输注后样本数据相关。结合多次评估可得到</span><span class="color_793286 f_w">myPKFiT</span><span>的个体剂量计算值。</span>`
        },
        {
          id: 2,
          name: 'IU（国际单位）',
          body: '国际单位定义为1毫升新鲜正常人血浆中检测到的FVIII含量。'
        },
        {
          id: 3,
          name: 'dL （分升）',
          body: '十分之一升的容量公制单位。'
        },
        {
          id: 4,
          name: '洗脱',
          body: '洗脱期是指所测出的FVIII水平可低于实验检测的限度或患者FVIII基线，即之前通过FVIII输注的外源性FVIII已在体内存量极少或彻底消失。完全洗脱所需的时间与FVIII输注量及患者个人的PK有关。洗脱通常为输注后约5至7个半衰期。百因止输注后的洗脱一般需要至少48-72小时。'
        },
        {
          id: 5,
          name: 'PK',
          body: '药代动力学（PK）是药物在机体内代谢过程的研究，即药物吸收、分布、代谢及排出。'
        },
        {
          id: 6,
          name: 'PK输注',
          body: 'PK输注是血液样本采集前用于确定个体FVIII的PK参数的单次迅速输注FVIII。'
        },
        {
          id: 7,
          name: 'FVIII',
          body: '因子VIII（FVIII）为重要的凝血因子，又称为抗血友病因子（AHF）。血友病A患者体内的FVIII活性较低或不存在。'
        },
        {
          id: 8,
          name: 'FVIII半衰期',
          body: `<span class="color_793286 f_w">myPKFiT</span><span>使用终末半衰期来计算PK和剂量。终末半衰期是测定药物在机内血浆/血液中完全降解的时间。</span>`
        },
        {
          id: 9,
          name: '清除率',
          body: '清除率是测定药物从系统中完全降解的效率和速率。清除率指在单位时间及每千克体重下，机体能将多少容积血液或血浆中的药物完全清除。'
        },
        {
          id: 10,
          name: 'Vss',
          body: '稳态分布容积（Vss）是根据平衡条件下药物在血浆或血液中的浓度得出的包含活性药物总量的体液假设容积。'
        },
        {
          id: 11,
          name: '至基线1%以上的时间',
          body: '在FVIII基线以上，达到FVIII目标谷浓度1%时的时间。'
        },
        {
          id: 12,
          name: 'FVIII基线',
          body: '无治疗性输注时的内源性循环FVIII水平。'
        },
        {
          id: 13,
          name: '个体PK特征曲线',
          body: `<span class="color_793286 f_w">myPKFiT</span><span>的计算结果。根据百因止临床研究数据上发布的群体PK模型进行。群体PK模型整合了贝叶斯算法并使用了二室模型，根据有限的血液样本和用于计算的PK参数估算值来得出个体FVIII在时间曲线上的估算值，提供剂量指南以维持选定时间间隔内的预期FVIII活性水平。个体PK特征曲线显示了估算的FVIII活性时间曲线以及用于进行PK评估的包含/排除的样本数据点。</span>`
        },
        {
          id: 14,
          name: '群体PK',
          body: `<span>群体PK研究不同个体在使用临床有效剂量的药物后药物与机体的关联性，同时也研究患者的群体特征。</span><span class="color_793286 f_w">myPKFiT</span><span>医疗软件的百因止群体PK研究以在临床研究项目中输注百因止（rAHFM-PFM）并有完整PK评估记录的152名重度血友病A患者群体（Björkman等人，2012年）为基础。</span>`
        },
        {
          id: 15,
          name: 'FVIII一步法分析',
          body: `一步法凝血试验是用对照样本和试验样本来比较FVIII缺乏的血浆改善其凝血时间的能力。<br>患者样本的凝血时间与标准曲线相对比，标准曲线是由稀释比例不同、特定因子活性为100%的标准血浆得出的。因此凝血因子活性数值用标准样本活性的％来表示。`
        },
        {
          id: 16,
          name: 'FVIII发色底物法分析',
          body: '发色底物法测试是测定FVIII促进发色底物裂解的能力。激活的因子VIII可加速IXa-介导的转化过程，使因子X转化为因子Xa。所产生的颜色浓度即代表因子VIII的活性。'
        },
        {
          id: 17,
          name: 'BLQ（定量下限以下）',
          body: '定量下限以下这个概念是指FVIII活性水平低于可以准确稳定测定的或当地实验室测试精度的最低浓度。'
        },
        {
          id: 18,
          name: '改进的贝叶斯算法',
          body: `<span>改进的</span><span class="color_793286 f_w">myPKFiT</span>
                <span>算法通过对患者FVIII表观消除率的初步评估来确保使用该患者合适的贝叶斯先验数据。在传统贝叶斯检测方法运用之前，如果患者的活性时间数据显示适合，经预设步骤获得的消除率经验预估值将暂时用于完善贝叶斯先验数据以完成一次数据运算。因此改进的</span><span class="color_793286 f_w">myPKFiT</span>
                <span>算法中采用了传统贝叶斯算法，可从先验数据的修正中受益，例如当患者的FⅧ活性表明其半衰期比典型预计的半衰期短的时候。</span>`
        },
        {
          id: 19,
          name: '贝叶斯先验数据',
          body: `<span>在贝叶斯算法结构中，不确定参数的先验值分布显示了任何可能的期望运算结果，而这些结果恰恰是基于可获得相关知识和/或数据参数计算而来的。用于</span><span class="color_793286 f_w">myPKFiT</span><span>的先验数据来源于使用百因止的大量重度血友病A患者群体的PK信息。</span>`
        },
        {
          id: 20,
          name: '拟合优度',
          body: '统计模型的拟合优度是指该模型拟合一套观察值的拟合程度。'
        }
      ],
      baseUrl: process.env.config.baseUrl,
      iframeUrl: '',
      openId: '',
      returnurl: decodeURIComponent(this.$route.query.returnurl || ''),
      oriUrl: this.$route.query.returnurl || '',
      needReturn: this.$route.query.needReturn || '',
      takedacode: this.$route.query.takedacode || '',
      jumptovctag: this.$route.query.jumptovctag || '',
      NewerTag: this.$route.query.NewerTag || '',
      showPage: false
    }
  },
  components: { agreeBookDialog },
  created () {

//判断会传参数中是否有 jumptovctag ，如有则证明已经跳过了，如无，则无论如何都跳转
if(!this.jumptovctag){
  this.iframeUrl = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myInstructionBook?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = this.iframeUrl
 }

      //如果参数中含有新用户标记，则清理缓存 (当前未考虑员工，仅考虑了医生)
      if(this.NewerTag=='Hcp'){
      window.sessionStorage.removeItem("LsData");
                // 注册成功删除暂存的用户信息
      window.localStorage.removeItem("registerUserInfo");
      window.localStorage.removeItem("registerNonHCPInfo");
                // 删除员工标识
      window.localStorage.removeItem("isEmployee");
    }
    else if(this.NewerTag=='Emp')
    {
      window.localStorage.setItem('isEmployee', true);

    }
    else if(this.NewerTag=='NoHcp')
    {
      window.localStorage.removeItem("registerNonHCPInfo");
      window.localStorage.removeItem("registerUserInfo");
    }

    if (!localStorage.TaToken && !this.takedacode) {
      this.iframeUrl = process.env.config.baseUrl + '/api/wechat/oauth2/authorize?redirect_uri=' + encodeURIComponent('https://' + window.location.host + '/myInstructionBook?returnurl=' + encodeURIComponent((this.oriUrl || '')))
      window.location.href = this.iframeUrl
    } else {
      if (this.takedacode && !localStorage.TaToken) {
        this.$axiox.get('/Login/GetTokenByCode?code=' + this.takedacode).then(msg => {
          localStorage.TaToken = msg.token
          localStorage.appId = msg.appId
          localStorage.openId = msg.openId
          this.openId = msg.openId
          this.showPage = true
        })
      } else {
        this.openId = localStorage.openId
        this.showPage = true
      }
    }

      setTimeout(() => {
        this.getSignDetail();
        this.$router.push({
query:merge(this.$route.query,{'jumptovctag':''})
})
      }, 1000);


  },
  mounted () {
  },
  methods: {
    getSignDetail() {
      let data = {
        openid: this.openId,
        docCode: "",
      };
      this.$axiox.postNoRes("/api/hcp/getHcpSignDetail", data).then((p) => {
        if (p.data == "True") {
          //name: "agreeBook",
            this.ABDialogShow = true;
        } else if (p.data == "False") {
        } //无需重新签署
        else {
        } //返回值错误
      });
    },
    ABDialogShowFn() {
      this.ABDialogShow =false;
    },
    clickProd (num) {
      this.selProd = num
      this.showMenu = false
      if (document.getElementById('myPkIndex')) {
        document.getElementById('myPkIndex').scroll(0, 0)
      }
      let data = {
        openId: this.openId,
        behavior: num === 1 ? '点击myPKFit说明书切换按钮' : '点击百因止说明书切换按钮'
      }
      this.$axiox.post('/api/Logs/AddUserBehavior', data).then(msg => {
        console.log(msg, '说明书切换 埋点')
      })
    },
    seltNavigate (e, item) {
      e.stopPropagation();
      this.seltMenuID = item.divID
      let data = {
        openId: this.openId,
        behavior: '点击myPKFit说明书导航栏-' + item.name
      }
      this.$axiox.post('/api/Logs/AddUserBehavior', data).then(msg => {
        console.log(msg, '点击myPKFit说明书导航栏 埋点')
      })
    },
    returnColor (type) {
      switch (type) {
        case 1:
          return 'color_redb94a48'
        case 2:
          return 'color_yelloae8740'
        case 3:
          return 'color_Purple7030a0'
      }
      return ''
    },
    returnBckColor (type) {
      switch (type) {
        case 1:
          return 'back_colorredffdddd'
        case 2:
          return 'back_colorYellofcf8e3'
        case 3:
          return ''
      }
      return ''
    },
    upDown () {
      let data = {
        openId: this.openId,
        behavior: this.selProd === 1 ? '下载myPKFit说明书' : '下载百因止说明书'
      }
      this.$axiox.post('/api/Logs/AddUserBehavior', data).then(msg => {
        console.log(msg, '说明书下载 埋点')
        let name = this.selProd === 1 ? 'myPKFiT_Instruction.docx' : 'ADVATE_Instruction.pdf'
        let url = decodeURIComponent(this.baseUrl + '/api/Article/GetAudioFileByName?fileName=' + name)
        let a = document.createElement('a')
        a.download = 'download'
        a.href = url
        a.click()
        window.location.href = url
      })
    }
  }
}
</script>

<style scoped>
.text_in {
  text-indent: 2em;
}
.leR {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.leR > span {
  /*margin-top: 2px;*/
  width: 52px;
}
.leR > div {
  width: calc(100% - 54px);
}
.color_yelloae8740{
  color: #ae8740;
}
.color_redb94a48 {
  color: #b94a48;
}
.color_Purple7030a0 {
  color: #7030a0;
}
.back_colorYellofcf8e3 {
  background-color: #fcf8e3;
}
.back_colorredffdddd {
  background-color: #ffdddd;
}
.proTable {
  width: 100%;
  border-collapse:collapse;
  border: 1px solid #7D55C6;
}
.proTable1 {
  width: 100%;
  border-collapse:collapse;
  border: 1px solid #000000;
}
.proTable1 th, .proTable1 td {
  border-collapse:collapse;
  border: 1px solid #000000;
  padding: 5px;
}
.proTable thead tr {
  background-color: #7D55C6;
}
.proTable thead tr th{
  color: white;
  padding: 5px;
}
.proTable td{
  border-collapse:collapse;
  border: 1px solid #7D55C6;
  padding: 5px;
  vertical-align: top;
}
.DfiBlue {
  display: inline-block;
  vertical-align: middle;
  width: 5px;
  height: 5px;
  background-color: #2e7dd8;
  transform: rotate(45deg);
}
.squareRed {
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 10px;
  background-color: #cc0860;
}
.triBlue {
  display: inline-block;
  vertical-align: middle;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 10px solid #2e7dd8;
}
.triRed {
  display: inline-block;
  vertical-align: middle;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 10px solid #cc0860;
}
.areaGreen {
  display: inline-block;
  vertical-align: middle;
  width: 16px;
  height: 8px;
  border-radius: 5px;
  background-color: #99ff99;
}
</style>



// WEBPACK FOOTER //
// src/components/myPkFit/myInstructionBook.vue